import '../../assets/DatePicker.css';var Ln = Object.defineProperty;
var Fn = (n, a, t) => a in n ? Ln(n, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[a] = t;
var b = (n, a, t) => Fn(n, typeof a != "symbol" ? a + "" : a, t);
import { jsxs as Jr, jsx as Se } from "react/jsx-runtime";
import * as T from "react";
import m, { useLayoutEffect as en, cloneElement as tn, createRef as Oe, Component as Z, useRef as kt, useCallback as An, useEffect as Hn, createElement as Wn, useState as Bn, forwardRef as Qn } from "react";
import { a as ye, b as ve } from "../../addMonths-Ca2KMx6g.mjs";
import { t as M, c as G, m as Lt, a as Ft, s as tt, d as rt, g as ir, b as Kn, e as Vn, h as xt, i as rn, j as Un, k as nn, l as an, n as qn, o as Zt, p as $n, w as br, q as jn, r as Pe, u as Jt, v as lr, f as er } from "../../format-DF9p-6BI.mjs";
import { s as Le, a as zn } from "../../subMonths-YdVF7zsL.mjs";
import { r as Xn, R as Gn } from "../../index-YbL9dKxh.mjs";
import { Input as Zn } from "../Input/Input.js";
function cr(n, a) {
  const t = +M(n);
  return G(n, t + a);
}
function Jn(n, a) {
  return cr(n, a * Lt);
}
function tr(n, a) {
  return cr(n, a * Ft);
}
function ur(n, a) {
  const t = a * 3;
  return ye(n, t);
}
function ea(n, a) {
  return cr(n, a * 1e3);
}
function Mt(n, a) {
  const t = a * 7;
  return ve(n, t);
}
function xe(n, a) {
  return ye(n, a * 12);
}
function _r(n) {
  let a;
  return n.forEach(function(t) {
    const e = M(t);
    (a === void 0 || a < e || isNaN(Number(e))) && (a = e);
  }), a || /* @__PURE__ */ new Date(NaN);
}
function kr(n) {
  let a;
  return n.forEach((t) => {
    const e = M(t);
    (!a || a > e || isNaN(+e)) && (a = e);
  }), a || /* @__PURE__ */ new Date(NaN);
}
function ta(n, a) {
  const t = tt(n), e = tt(a);
  return +t == +e;
}
function Ct(n, a) {
  const t = M(n), e = M(a), r = t.getFullYear() - e.getFullYear(), o = t.getMonth() - e.getMonth();
  return r * 12 + o;
}
function Fe(n) {
  const a = M(n);
  return Math.trunc(a.getMonth() / 3) + 1;
}
function St(n, a) {
  const t = M(n), e = M(a), r = t.getFullYear() - e.getFullYear(), o = Fe(t) - Fe(e);
  return r * 4 + o;
}
function Et(n, a) {
  const t = M(n), e = M(a);
  return t.getFullYear() - e.getFullYear();
}
function ra(n, a) {
  const t = M(n), e = M(a), r = xr(t, e), o = Math.abs(rt(t, e));
  t.setDate(t.getDate() - r * o);
  const s = +(xr(t, e) === -r), i = r * (o - s);
  return i === 0 ? 0 : i;
}
function xr(n, a) {
  const t = n.getFullYear() - a.getFullYear() || n.getMonth() - a.getMonth() || n.getDate() - a.getDate() || n.getHours() - a.getHours() || n.getMinutes() - a.getMinutes() || n.getSeconds() - a.getSeconds() || n.getMilliseconds() - a.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function on(n) {
  const a = M(n);
  return a.setHours(23, 59, 59, 999), a;
}
function sn(n) {
  const a = M(n), t = a.getMonth();
  return a.setFullYear(a.getFullYear(), t + 1, 0), a.setHours(23, 59, 59, 999), a;
}
function rr(n) {
  const a = M(n), t = a.getMonth(), e = t - t % 3;
  return a.setMonth(e, 1), a.setHours(0, 0, 0, 0), a;
}
function ln(n) {
  const a = M(n);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function cn(n) {
  const a = M(n), t = a.getFullYear();
  return a.setFullYear(t + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function na(n, a) {
  var i, l;
  const t = ir(), e = t.weekStartsOn ?? ((l = (i = t.locale) == null ? void 0 : i.options) == null ? void 0 : l.weekStartsOn) ?? 0, r = M(n), o = r.getDay(), s = (o < e ? -7 : 0) + 6 - (o - e);
  return r.setDate(r.getDate() + s), r.setHours(23, 59, 59, 999), r;
}
function Mr(n) {
  return M(n).getDate();
}
function aa(n) {
  return M(n).getDay();
}
function oa(n) {
  const a = M(n), t = a.getFullYear(), e = a.getMonth(), r = G(n, 0);
  return r.setFullYear(t, e + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function sa() {
  return Object.assign({}, ir());
}
function ge(n) {
  return M(n).getHours();
}
function ia(n) {
  let t = M(n).getDay();
  return t === 0 && (t = 7), t;
}
function De(n) {
  return M(n).getMinutes();
}
function ne(n) {
  return M(n).getMonth();
}
function Me(n) {
  return M(n).getSeconds();
}
function nr(n) {
  return M(n).getTime();
}
function Y(n) {
  return M(n).getFullYear();
}
function Ne(n, a) {
  const t = M(n), e = M(a);
  return t.getTime() > e.getTime();
}
function We(n, a) {
  const t = M(n), e = M(a);
  return +t < +e;
}
function la(n, a) {
  const t = M(n), e = M(a);
  return +t == +e;
}
function ca(n, a) {
  const t = a instanceof Date ? G(a, 0) : new a(0);
  return t.setFullYear(
    n.getFullYear(),
    n.getMonth(),
    n.getDate()
  ), t.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), t;
}
const ua = 10;
class un {
  constructor() {
    b(this, "subPriority", 0);
  }
  validate(a, t) {
    return !0;
  }
}
class da extends un {
  constructor(a, t, e, r, o) {
    super(), this.value = a, this.validateValue = t, this.setValue = e, this.priority = r, o && (this.subPriority = o);
  }
  validate(a, t) {
    return this.validateValue(a, this.value, t);
  }
  set(a, t, e) {
    return this.setValue(a, t, this.value, e);
  }
}
class pa extends un {
  constructor() {
    super(...arguments);
    b(this, "priority", ua);
    b(this, "subPriority", -1);
  }
  set(t, e) {
    return e.timestampIsSet ? t : G(t, ca(t, Date));
  }
}
class H {
  run(a, t, e, r) {
    const o = this.parse(a, t, e, r);
    return o ? {
      setter: new da(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(a, t, e) {
    return !0;
  }
}
class fa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 140);
    b(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, e, r) {
    return e.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const j = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, fe = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function z(n, a) {
  return n && {
    value: a(n.value),
    rest: n.rest
  };
}
function q(n, a) {
  const t = a.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: a.slice(t[0].length)
  } : null;
}
function he(n, a) {
  const t = a.match(n);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  const e = t[1] === "+" ? 1 : -1, r = t[2] ? parseInt(t[2], 10) : 0, o = t[3] ? parseInt(t[3], 10) : 0, s = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: e * (r * Lt + o * Ft + s * Kn),
    rest: a.slice(t[0].length)
  };
}
function dn(n) {
  return q(j.anyDigitsSigned, n);
}
function $(n, a) {
  switch (n) {
    case 1:
      return q(j.singleDigit, a);
    case 2:
      return q(j.twoDigits, a);
    case 3:
      return q(j.threeDigits, a);
    case 4:
      return q(j.fourDigits, a);
    default:
      return q(new RegExp("^\\d{1," + n + "}"), a);
  }
}
function Pt(n, a) {
  switch (n) {
    case 1:
      return q(j.singleDigitSigned, a);
    case 2:
      return q(j.twoDigitsSigned, a);
    case 3:
      return q(j.threeDigitsSigned, a);
    case 4:
      return q(j.fourDigitsSigned, a);
    default:
      return q(new RegExp("^-?\\d{1," + n + "}"), a);
  }
}
function dr(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function pn(n, a) {
  const t = a > 0, e = t ? a : 1 - a;
  let r;
  if (e <= 50)
    r = n || 100;
  else {
    const o = e + 50, s = Math.trunc(o / 100) * 100, i = n >= o % 100;
    r = n + s - (i ? 100 : 0);
  }
  return t ? r : 1 - r;
}
function fn(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class ha extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: e === "yy"
    });
    switch (e) {
      case "y":
        return z($(4, t), o);
      case "yo":
        return z(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return z($(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r) {
    const o = t.getFullYear();
    if (r.isTwoDigitYear) {
      const i = pn(
        r.year,
        o
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const s = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ma extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: e === "YY"
    });
    switch (e) {
      case "Y":
        return z($(4, t), o);
      case "Yo":
        return z(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return z($(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r, o) {
    const s = Vn(t, o);
    if (r.isTwoDigitYear) {
      const l = pn(
        r.year,
        s
      );
      return t.setFullYear(
        l,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), xt(t, o);
    }
    const i = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), xt(t, o);
  }
}
class va extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e) {
    return Pt(e === "R" ? 4 : e.length, t);
  }
  set(t, e, r) {
    const o = G(t, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), rn(o);
  }
}
class ga extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return Pt(e === "u" ? 4 : e.length, t);
  }
  set(t, e, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Da extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 120);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "Q":
      case "QQ":
        return $(e.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class wa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 120);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "q":
      case "qq":
        return $(e.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ya extends H {
  constructor() {
    super(...arguments);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    b(this, "priority", 110);
  }
  parse(t, e, r) {
    const o = (s) => s - 1;
    switch (e) {
      case "M":
        return z(
          q(j.month, t),
          o
        );
      case "MM":
        return z($(2, t), o);
      case "Mo":
        return z(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ba extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 110);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (s) => s - 1;
    switch (e) {
      case "L":
        return z(
          q(j.month, t),
          o
        );
      case "LL":
        return z($(2, t), o);
      case "Lo":
        return z(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function _a(n, a, t) {
  const e = M(n), r = Un(e, t) - a;
  return e.setDate(e.getDate() - r * 7), e;
}
class ka extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 100);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "w":
        return q(j.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r, o) {
    return xt(_a(t, r, o), o);
  }
}
function xa(n, a) {
  const t = M(n), e = nn(t) - a;
  return t.setDate(t.getDate() - e * 7), t;
}
class Ma extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 100);
    b(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "I":
        return q(j.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r) {
    return rn(xa(t, r));
  }
}
const Ca = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Sa = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Ea extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "subPriority", 1);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "d":
        return q(j.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear(), o = fn(r), s = t.getMonth();
    return o ? e >= 1 && e <= Sa[s] : e >= 1 && e <= Ca[s];
  }
  set(t, e, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}
class Pa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "subpriority", 1);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "D":
      case "DD":
        return q(j.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear();
    return fn(r) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(t, e, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
}
function pr(n, a, t) {
  var d, p, f, h;
  const e = ir(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? e.weekStartsOn ?? ((h = (f = e.locale) == null ? void 0 : f.options) == null ? void 0 : h.weekStartsOn) ?? 0, o = M(n), s = o.getDay(), l = (a % 7 + 7) % 7, c = 7 - r, u = a < 0 || a > 6 ? a - (s + c) % 7 : (l + c) % 7 - (s + c) % 7;
  return ve(o, u);
}
class Ta extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = pr(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Oa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const s = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (e) {
      case "e":
      case "ee":
        return z($(e.length, t), s);
      case "eo":
        return z(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = pr(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Na extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const s = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (e) {
      case "c":
      case "cc":
        return z($(e.length, t), s);
      case "co":
        return z(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = pr(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
function Ra(n, a) {
  const t = M(n), e = ia(t), r = a - e;
  return ve(t, r);
}
class Ya extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (s) => s === 0 ? 7 : s;
    switch (e) {
      case "i":
      case "ii":
        return $(e.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return z(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return z(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return z(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return z(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 7;
  }
  set(t, e, r) {
    return t = Ra(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
class Ia extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 80);
    b(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(dr(r), 0, 0, 0), t;
  }
}
class La extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 80);
    b(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(dr(r), 0, 0, 0), t;
  }
}
class Fa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 80);
    b(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(dr(r), 0, 0, 0), t;
  }
}
class Aa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "h":
        return q(j.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 12;
  }
  set(t, e, r) {
    const o = t.getHours() >= 12;
    return o && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class Ha extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "H":
        return q(j.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 23;
  }
  set(t, e, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
}
class Wa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "K":
        return q(j.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class Ba extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "k":
        return q(j.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 24;
  }
  set(t, e, r) {
    const o = r <= 24 ? r % 24 : r;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class Qa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 60);
    b(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "m":
        return q(j.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class Ka extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 50);
    b(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "s":
        return q(j.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setSeconds(r, 0), t;
  }
}
class Va extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 30);
    b(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e) {
    const r = (o) => Math.trunc(o * Math.pow(10, -e.length + 3));
    return z($(e.length, t), r);
  }
  set(t, e, r) {
    return t.setMilliseconds(r), t;
  }
}
class Ua extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 10);
    b(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, e) {
    switch (e) {
      case "X":
        return he(
          fe.basicOptionalMinutes,
          t
        );
      case "XX":
        return he(fe.basic, t);
      case "XXXX":
        return he(
          fe.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return he(
          fe.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return he(fe.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : G(
      t,
      t.getTime() - an(t) - r
    );
  }
}
class qa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 10);
    b(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, e) {
    switch (e) {
      case "x":
        return he(
          fe.basicOptionalMinutes,
          t
        );
      case "xx":
        return he(fe.basic, t);
      case "xxxx":
        return he(
          fe.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return he(
          fe.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return he(fe.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : G(
      t,
      t.getTime() - an(t) - r
    );
  }
}
class $a extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 40);
    b(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return dn(t);
  }
  set(t, e, r) {
    return [G(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class ja extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 20);
    b(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return dn(t);
  }
  set(t, e, r) {
    return [G(t, r), { timestampIsSet: !0 }];
  }
}
const za = {
  G: new fa(),
  y: new ha(),
  Y: new ma(),
  R: new va(),
  u: new ga(),
  Q: new Da(),
  q: new wa(),
  M: new ya(),
  L: new ba(),
  w: new ka(),
  I: new Ma(),
  d: new Ea(),
  D: new Pa(),
  E: new Ta(),
  e: new Oa(),
  c: new Na(),
  i: new Ya(),
  a: new Ia(),
  b: new La(),
  B: new Fa(),
  h: new Aa(),
  H: new Ha(),
  K: new Wa(),
  k: new Ba(),
  m: new Qa(),
  s: new Ka(),
  S: new Va(),
  X: new Ua(),
  x: new qa(),
  t: new $a(),
  T: new ja()
}, Xa = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ga = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Za = /^'([^]*?)'?$/, Ja = /''/g, eo = /\S/, to = /[a-zA-Z]/;
function Kt(n, a, t, e) {
  var g, v, D, x, k, E, S, N;
  const r = sa(), o = (e == null ? void 0 : e.locale) ?? r.locale ?? qn, s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((v = (g = e == null ? void 0 : e.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((x = (D = r.locale) == null ? void 0 : D.options) == null ? void 0 : x.firstWeekContainsDate) ?? 1, i = (e == null ? void 0 : e.weekStartsOn) ?? ((E = (k = e == null ? void 0 : e.locale) == null ? void 0 : k.options) == null ? void 0 : E.weekStartsOn) ?? r.weekStartsOn ?? ((N = (S = r.locale) == null ? void 0 : S.options) == null ? void 0 : N.weekStartsOn) ?? 0;
  if (a === "")
    return n === "" ? M(t) : G(t, NaN);
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: o
  }, c = [new pa()], u = a.match(Ga).map((w) => {
    const _ = w[0];
    if (_ in Zt) {
      const C = Zt[_];
      return C(w, o.formatLong);
    }
    return w;
  }).join("").match(Xa), d = [];
  for (let w of u) {
    !(e != null && e.useAdditionalWeekYearTokens) && $n(w) && br(w, a, n), !(e != null && e.useAdditionalDayOfYearTokens) && jn(w) && br(w, a, n);
    const _ = w[0], C = za[_];
    if (C) {
      const { incompatibleTokens: I } = C;
      if (Array.isArray(I)) {
        const A = d.find(
          (K) => I.includes(K.token) || K.token === _
        );
        if (A)
          throw new RangeError(
            `The format string mustn't contain \`${A.fullToken}\` and \`${w}\` at the same time`
          );
      } else if (C.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${w}\` and any other token at the same time`
        );
      d.push({ token: _, fullToken: w });
      const W = C.run(
        n,
        w,
        o.match,
        l
      );
      if (!W)
        return G(t, NaN);
      c.push(W.setter), n = W.rest;
    } else {
      if (_.match(to))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (w === "''" ? w = "'" : _ === "'" && (w = ro(w)), n.indexOf(w) === 0)
        n = n.slice(w.length);
      else
        return G(t, NaN);
    }
  }
  if (n.length > 0 && eo.test(n))
    return G(t, NaN);
  const p = c.map((w) => w.priority).sort((w, _) => _ - w).filter((w, _, C) => C.indexOf(w) === _).map(
    (w) => c.filter((_) => _.priority === w).sort((_, C) => C.subPriority - _.subPriority)
  ).map((w) => w[0]);
  let f = M(t);
  if (isNaN(f.getTime()))
    return G(t, NaN);
  const h = {};
  for (const w of p) {
    if (!w.validate(f, l))
      return G(t, NaN);
    const _ = w.set(f, h, l);
    Array.isArray(_) ? (f = _[0], Object.assign(h, _[1])) : f = _;
  }
  return G(t, f);
}
function ro(n) {
  return n.match(Za)[1].replace(Ja, "'");
}
function no(n, a) {
  const t = M(n), e = M(a);
  return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
}
function ao(n, a) {
  const t = rr(n), e = rr(a);
  return +t == +e;
}
function oo(n, a) {
  const t = M(n), e = M(a);
  return t.getFullYear() === e.getFullYear();
}
function nt(n, a) {
  const t = +M(n), [e, r] = [
    +M(a.start),
    +M(a.end)
  ].sort((o, s) => o - s);
  return t >= e && t <= r;
}
function so(n, a) {
  const e = uo(n);
  let r;
  if (e.date) {
    const l = po(e.date, 2);
    r = fo(l.restDateString, l.year);
  }
  if (!r || isNaN(r.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = r.getTime();
  let s = 0, i;
  if (e.time && (s = ho(e.time), isNaN(s)))
    return /* @__PURE__ */ new Date(NaN);
  if (e.timezone) {
    if (i = mo(e.timezone), isNaN(i))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(o + s), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), c.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), c;
  }
  return new Date(o + s + i);
}
const ut = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, io = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, lo = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, co = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function uo(n) {
  const a = {}, t = n.split(ut.dateTimeDelimiter);
  let e;
  if (t.length > 2)
    return a;
  if (/:/.test(t[0]) ? e = t[0] : (a.date = t[0], e = t[1], ut.timeZoneDelimiter.test(a.date) && (a.date = n.split(ut.timeZoneDelimiter)[0], e = n.substr(
    a.date.length,
    n.length
  ))), e) {
    const r = ut.timezone.exec(e);
    r ? (a.time = e.replace(r[1], ""), a.timezone = r[1]) : a.time = e;
  }
  return a;
}
function po(n, a) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + a) + "})|(\\d{2}|[+-]\\d{" + (2 + a) + "})$)"
  ), e = n.match(t);
  if (!e) return { year: NaN, restDateString: "" };
  const r = e[1] ? parseInt(e[1]) : null, o = e[2] ? parseInt(e[2]) : null;
  return {
    year: o === null ? r : o * 100,
    restDateString: n.slice((e[1] || e[2]).length)
  };
}
function fo(n, a) {
  if (a === null) return /* @__PURE__ */ new Date(NaN);
  const t = n.match(io);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const e = !!t[4], r = Xe(t[1]), o = Xe(t[2]) - 1, s = Xe(t[3]), i = Xe(t[4]), l = Xe(t[5]) - 1;
  if (e)
    return yo(a, i, l) ? vo(a, i, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !Do(a, o, s) || !wo(a, r) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(a, o, Math.max(r, s)), c);
  }
}
function Xe(n) {
  return n ? parseInt(n) : 1;
}
function ho(n) {
  const a = n.match(lo);
  if (!a) return NaN;
  const t = Vt(a[1]), e = Vt(a[2]), r = Vt(a[3]);
  return bo(t, e, r) ? t * Lt + e * Ft + r * 1e3 : NaN;
}
function Vt(n) {
  return n && parseFloat(n.replace(",", ".")) || 0;
}
function mo(n) {
  if (n === "Z") return 0;
  const a = n.match(co);
  if (!a) return 0;
  const t = a[1] === "+" ? -1 : 1, e = parseInt(a[2]), r = a[3] && parseInt(a[3]) || 0;
  return _o(e, r) ? t * (e * Lt + r * Ft) : NaN;
}
function vo(n, a, t) {
  const e = /* @__PURE__ */ new Date(0);
  e.setUTCFullYear(n, 0, 4);
  const r = e.getUTCDay() || 7, o = (a - 1) * 7 + t + 1 - r;
  return e.setUTCDate(e.getUTCDate() + o), e;
}
const go = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function hn(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
function Do(n, a, t) {
  return a >= 0 && a <= 11 && t >= 1 && t <= (go[a] || (hn(n) ? 29 : 28));
}
function wo(n, a) {
  return a >= 1 && a <= (hn(n) ? 366 : 365);
}
function yo(n, a, t) {
  return a >= 1 && a <= 53 && t >= 0 && t <= 6;
}
function bo(n, a, t) {
  return n === 24 ? a === 0 && t === 0 : t >= 0 && t < 60 && a >= 0 && a < 60 && n >= 0 && n < 25;
}
function _o(n, a) {
  return a >= 0 && a <= 59;
}
function ae(n, a) {
  const t = M(n), e = t.getFullYear(), r = t.getDate(), o = G(n, 0);
  o.setFullYear(e, a, 15), o.setHours(0, 0, 0, 0);
  const s = oa(o);
  return t.setMonth(a, Math.min(r, s)), t;
}
function ko(n, a) {
  let t = M(n);
  return isNaN(+t) ? G(n, NaN) : (a.year != null && t.setFullYear(a.year), a.month != null && (t = ae(t, a.month)), a.date != null && t.setDate(a.date), a.hours != null && t.setHours(a.hours), a.minutes != null && t.setMinutes(a.minutes), a.seconds != null && t.setSeconds(a.seconds), a.milliseconds != null && t.setMilliseconds(a.milliseconds), t);
}
function gt(n, a) {
  const t = M(n);
  return t.setHours(a), t;
}
function Dt(n, a) {
  const t = M(n);
  return t.setMinutes(a), t;
}
function Qe(n, a) {
  const t = M(n), e = Math.trunc(t.getMonth() / 3) + 1, r = a - e;
  return ae(t, t.getMonth() + r * 3);
}
function wt(n, a) {
  const t = M(n);
  return t.setSeconds(a), t;
}
function de(n, a) {
  const t = M(n);
  return isNaN(+t) ? G(n, NaN) : (t.setFullYear(a), t);
}
function mn(n, a) {
  return ur(n, -1);
}
function Cr(n, a) {
  return Mt(n, -1);
}
function Ue(n, a) {
  return xe(n, -a);
}
function vn(n) {
  var a, t, e = "";
  if (typeof n == "string" || typeof n == "number") e += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var r = n.length;
    for (a = 0; a < r; a++) n[a] && (t = vn(n[a])) && (e && (e += " "), e += t);
  } else for (t in n) n[t] && (e && (e += " "), e += t);
  return e;
}
function ee() {
  for (var n, a, t = 0, e = "", r = arguments.length; t < r; t++) (n = arguments[t]) && (a = vn(n)) && (e && (e += " "), e += a);
  return e;
}
function At() {
  return typeof window < "u";
}
function ze(n) {
  return gn(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function oe(n) {
  var a;
  return (n == null || (a = n.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function _e(n) {
  var a;
  return (a = (gn(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : a.documentElement;
}
function gn(n) {
  return At() ? n instanceof Node || n instanceof oe(n).Node : !1;
}
function te(n) {
  return At() ? n instanceof Element || n instanceof oe(n).Element : !1;
}
function be(n) {
  return At() ? n instanceof HTMLElement || n instanceof oe(n).HTMLElement : !1;
}
function Sr(n) {
  return !At() || typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof oe(n).ShadowRoot;
}
function st(n) {
  const {
    overflow: a,
    overflowX: t,
    overflowY: e,
    display: r
  } = le(n);
  return /auto|scroll|overlay|hidden|clip/.test(a + e + t) && !["inline", "contents"].includes(r);
}
function xo(n) {
  return ["table", "td", "th"].includes(ze(n));
}
function Ht(n) {
  return [":popover-open", ":modal"].some((a) => {
    try {
      return n.matches(a);
    } catch {
      return !1;
    }
  });
}
function fr(n) {
  const a = hr(), t = te(n) ? le(n) : n;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((e) => t[e] ? t[e] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !a && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !a && (t.filter ? t.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((e) => (t.willChange || "").includes(e)) || ["paint", "layout", "strict", "content"].some((e) => (t.contain || "").includes(e));
}
function Mo(n) {
  let a = Re(n);
  for (; be(a) && !qe(a); ) {
    if (fr(a))
      return a;
    if (Ht(a))
      return null;
    a = Re(a);
  }
  return null;
}
function hr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function qe(n) {
  return ["html", "body", "#document"].includes(ze(n));
}
function le(n) {
  return oe(n).getComputedStyle(n);
}
function Wt(n) {
  return te(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.scrollX,
    scrollTop: n.scrollY
  };
}
function Re(n) {
  if (ze(n) === "html")
    return n;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    Sr(n) && n.host || // Fallback.
    _e(n)
  );
  return Sr(a) ? a.host : a;
}
function Dn(n) {
  const a = Re(n);
  return qe(a) ? n.ownerDocument ? n.ownerDocument.body : n.body : be(a) && st(a) ? a : Dn(a);
}
function at(n, a, t) {
  var e;
  a === void 0 && (a = []), t === void 0 && (t = !0);
  const r = Dn(n), o = r === ((e = n.ownerDocument) == null ? void 0 : e.body), s = oe(r);
  if (o) {
    const i = ar(s);
    return a.concat(s, s.visualViewport || [], st(r) ? r : [], i && t ? at(i) : []);
  }
  return a.concat(r, at(r, [], t));
}
function ar(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
const $e = Math.min, Ae = Math.max, Tt = Math.round, dt = Math.floor, we = (n) => ({
  x: n,
  y: n
}), Co = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, So = {
  start: "end",
  end: "start"
};
function Eo(n, a, t) {
  return Ae(n, $e(a, t));
}
function Bt(n, a) {
  return typeof n == "function" ? n(a) : n;
}
function je(n) {
  return n.split("-")[0];
}
function it(n) {
  return n.split("-")[1];
}
function Po(n) {
  return n === "x" ? "y" : "x";
}
function mr(n) {
  return n === "y" ? "height" : "width";
}
function Ye(n) {
  return ["top", "bottom"].includes(je(n)) ? "y" : "x";
}
function vr(n) {
  return Po(Ye(n));
}
function To(n, a, t) {
  t === void 0 && (t = !1);
  const e = it(n), r = vr(n), o = mr(r);
  let s = r === "x" ? e === (t ? "end" : "start") ? "right" : "left" : e === "start" ? "bottom" : "top";
  return a.reference[o] > a.floating[o] && (s = Ot(s)), [s, Ot(s)];
}
function Oo(n) {
  const a = Ot(n);
  return [or(n), a, or(a)];
}
function or(n) {
  return n.replace(/start|end/g, (a) => So[a]);
}
function No(n, a, t) {
  const e = ["left", "right"], r = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return t ? a ? r : e : a ? e : r;
    case "left":
    case "right":
      return a ? o : s;
    default:
      return [];
  }
}
function Ro(n, a, t, e) {
  const r = it(n);
  let o = No(je(n), t === "start", e);
  return r && (o = o.map((s) => s + "-" + r), a && (o = o.concat(o.map(or)))), o;
}
function Ot(n) {
  return n.replace(/left|right|bottom|top/g, (a) => Co[a]);
}
function Yo(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function wn(n) {
  return typeof n != "number" ? Yo(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function Nt(n) {
  const {
    x: a,
    y: t,
    width: e,
    height: r
  } = n;
  return {
    width: e,
    height: r,
    top: t,
    left: a,
    right: a + e,
    bottom: t + r,
    x: a,
    y: t
  };
}
var Io = typeof document < "u", Lo = function() {
}, Rt = Io ? en : Lo;
const Fo = {
  ...T
}, Ao = Fo.useInsertionEffect, Ho = Ao || ((n) => n());
function Wo(n) {
  const a = T.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Ho(() => {
    a.current = n;
  }), T.useCallback(function() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    return a.current == null ? void 0 : a.current(...e);
  }, []);
}
function Er(n, a, t) {
  let {
    reference: e,
    floating: r
  } = n;
  const o = Ye(a), s = vr(a), i = mr(s), l = je(a), c = o === "y", u = e.x + e.width / 2 - r.width / 2, d = e.y + e.height / 2 - r.height / 2, p = e[i] / 2 - r[i] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: u,
        y: e.y - r.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: e.y + e.height
      };
      break;
    case "right":
      f = {
        x: e.x + e.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: e.x - r.width,
        y: d
      };
      break;
    default:
      f = {
        x: e.x,
        y: e.y
      };
  }
  switch (it(a)) {
    case "start":
      f[s] -= p * (t && c ? -1 : 1);
      break;
    case "end":
      f[s] += p * (t && c ? -1 : 1);
      break;
  }
  return f;
}
const Bo = async (n, a, t) => {
  const {
    placement: e = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: s
  } = t, i = o.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(a));
  let c = await s.getElementRects({
    reference: n,
    floating: a,
    strategy: r
  }), {
    x: u,
    y: d
  } = Er(c, e, l), p = e, f = {}, h = 0;
  for (let g = 0; g < i.length; g++) {
    const {
      name: v,
      fn: D
    } = i[g], {
      x,
      y: k,
      data: E,
      reset: S
    } = await D({
      x: u,
      y: d,
      initialPlacement: e,
      placement: p,
      strategy: r,
      middlewareData: f,
      rects: c,
      platform: s,
      elements: {
        reference: n,
        floating: a
      }
    });
    u = x ?? u, d = k ?? d, f = {
      ...f,
      [v]: {
        ...f[v],
        ...E
      }
    }, S && h <= 50 && (h++, typeof S == "object" && (S.placement && (p = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: n,
      floating: a,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = Er(c, p, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: r,
    middlewareData: f
  };
};
async function Qo(n, a) {
  var t;
  a === void 0 && (a = {});
  const {
    x: e,
    y: r,
    platform: o,
    rects: s,
    elements: i,
    strategy: l
  } = n, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = Bt(a, n), h = wn(f), v = i[p ? d === "floating" ? "reference" : "floating" : d], D = Nt(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(v))) == null || t ? v : v.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), x = d === "floating" ? {
    x: e,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, k = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(i.floating)), E = await (o.isElement == null ? void 0 : o.isElement(k)) ? await (o.getScale == null ? void 0 : o.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Nt(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: x,
    offsetParent: k,
    strategy: l
  }) : x);
  return {
    top: (D.top - S.top + h.top) / E.y,
    bottom: (S.bottom - D.bottom + h.bottom) / E.y,
    left: (D.left - S.left + h.left) / E.x,
    right: (S.right - D.right + h.right) / E.x
  };
}
const Ko = (n) => ({
  name: "arrow",
  options: n,
  async fn(a) {
    const {
      x: t,
      y: e,
      placement: r,
      rects: o,
      platform: s,
      elements: i,
      middlewareData: l
    } = a, {
      element: c,
      padding: u = 0
    } = Bt(n, a) || {};
    if (c == null)
      return {};
    const d = wn(u), p = {
      x: t,
      y: e
    }, f = vr(r), h = mr(f), g = await s.getDimensions(c), v = f === "y", D = v ? "top" : "left", x = v ? "bottom" : "right", k = v ? "clientHeight" : "clientWidth", E = o.reference[h] + o.reference[f] - p[f] - o.floating[h], S = p[f] - o.reference[f], N = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let w = N ? N[k] : 0;
    (!w || !await (s.isElement == null ? void 0 : s.isElement(N))) && (w = i.floating[k] || o.floating[h]);
    const _ = E / 2 - S / 2, C = w / 2 - g[h] / 2 - 1, I = $e(d[D], C), W = $e(d[x], C), A = I, K = w - g[h] - W, V = w / 2 - g[h] / 2 + _, B = Eo(A, V, K), P = !l.arrow && it(r) != null && V !== B && o.reference[h] / 2 - (V < A ? I : W) - g[h] / 2 < 0, R = P ? V < A ? V - A : V - K : 0;
    return {
      [f]: p[f] + R,
      data: {
        [f]: B,
        centerOffset: V - B - R,
        ...P && {
          alignmentOffset: R
        }
      },
      reset: P
    };
  }
}), Vo = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(a) {
      var t, e;
      const {
        placement: r,
        middlewareData: o,
        rects: s,
        initialPlacement: i,
        platform: l,
        elements: c
      } = a, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...v
      } = Bt(n, a);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const D = je(r), x = Ye(i), k = je(i) === i, E = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = p || (k || !g ? [Ot(i)] : Oo(i)), N = h !== "none";
      !p && N && S.push(...Ro(i, g, h, E));
      const w = [i, ...S], _ = await Qo(a, v), C = [];
      let I = ((e = o.flip) == null ? void 0 : e.overflows) || [];
      if (u && C.push(_[D]), d) {
        const V = To(r, s, E);
        C.push(_[V[0]], _[V[1]]);
      }
      if (I = [...I, {
        placement: r,
        overflows: C
      }], !C.every((V) => V <= 0)) {
        var W, A;
        const V = (((W = o.flip) == null ? void 0 : W.index) || 0) + 1, B = w[V];
        if (B && (!(d === "alignment" ? x !== Ye(B) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        I.every((O) => O.overflows[0] > 0 && Ye(O.placement) === x)))
          return {
            data: {
              index: V,
              overflows: I
            },
            reset: {
              placement: B
            }
          };
        let P = (A = I.filter((R) => R.overflows[0] <= 0).sort((R, O) => R.overflows[1] - O.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!P)
          switch (f) {
            case "bestFit": {
              var K;
              const R = (K = I.filter((O) => {
                if (N) {
                  const X = Ye(O.placement);
                  return X === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  X === "y";
                }
                return !0;
              }).map((O) => [O.placement, O.overflows.filter((X) => X > 0).reduce((X, ce) => X + ce, 0)]).sort((O, X) => O[1] - X[1])[0]) == null ? void 0 : K[0];
              R && (P = R);
              break;
            }
            case "initialPlacement":
              P = i;
              break;
          }
        if (r !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
};
async function Uo(n, a) {
  const {
    placement: t,
    platform: e,
    elements: r
  } = n, o = await (e.isRTL == null ? void 0 : e.isRTL(r.floating)), s = je(t), i = it(t), l = Ye(t) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = o && l ? -1 : 1, d = Bt(a, n);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return i && typeof h == "number" && (f = i === "end" ? h * -1 : h), l ? {
    x: f * u,
    y: p * c
  } : {
    x: p * c,
    y: f * u
  };
}
const qo = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(a) {
      var t, e;
      const {
        x: r,
        y: o,
        placement: s,
        middlewareData: i
      } = a, l = await Uo(a, n);
      return s === ((t = i.offset) == null ? void 0 : t.placement) && (e = i.arrow) != null && e.alignmentOffset ? {} : {
        x: r + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
};
function yn(n) {
  const a = le(n);
  let t = parseFloat(a.width) || 0, e = parseFloat(a.height) || 0;
  const r = be(n), o = r ? n.offsetWidth : t, s = r ? n.offsetHeight : e, i = Tt(t) !== o || Tt(e) !== s;
  return i && (t = o, e = s), {
    width: t,
    height: e,
    $: i
  };
}
function gr(n) {
  return te(n) ? n : n.contextElement;
}
function Ke(n) {
  const a = gr(n);
  if (!be(a))
    return we(1);
  const t = a.getBoundingClientRect(), {
    width: e,
    height: r,
    $: o
  } = yn(a);
  let s = (o ? Tt(t.width) : t.width) / e, i = (o ? Tt(t.height) : t.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const $o = /* @__PURE__ */ we(0);
function bn(n) {
  const a = oe(n);
  return !hr() || !a.visualViewport ? $o : {
    x: a.visualViewport.offsetLeft,
    y: a.visualViewport.offsetTop
  };
}
function jo(n, a, t) {
  return a === void 0 && (a = !1), !t || a && t !== oe(n) ? !1 : a;
}
function Be(n, a, t, e) {
  a === void 0 && (a = !1), t === void 0 && (t = !1);
  const r = n.getBoundingClientRect(), o = gr(n);
  let s = we(1);
  a && (e ? te(e) && (s = Ke(e)) : s = Ke(n));
  const i = jo(o, t, e) ? bn(o) : we(0);
  let l = (r.left + i.x) / s.x, c = (r.top + i.y) / s.y, u = r.width / s.x, d = r.height / s.y;
  if (o) {
    const p = oe(o), f = e && te(e) ? oe(e) : e;
    let h = p, g = ar(h);
    for (; g && e && f !== h; ) {
      const v = Ke(g), D = g.getBoundingClientRect(), x = le(g), k = D.left + (g.clientLeft + parseFloat(x.paddingLeft)) * v.x, E = D.top + (g.clientTop + parseFloat(x.paddingTop)) * v.y;
      l *= v.x, c *= v.y, u *= v.x, d *= v.y, l += k, c += E, h = oe(g), g = ar(h);
    }
  }
  return Nt({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Dr(n, a) {
  const t = Wt(n).scrollLeft;
  return a ? a.left + t : Be(_e(n)).left + t;
}
function _n(n, a, t) {
  t === void 0 && (t = !1);
  const e = n.getBoundingClientRect(), r = e.left + a.scrollLeft - (t ? 0 : (
    // RTL <body> scrollbar.
    Dr(n, e)
  )), o = e.top + a.scrollTop;
  return {
    x: r,
    y: o
  };
}
function zo(n) {
  let {
    elements: a,
    rect: t,
    offsetParent: e,
    strategy: r
  } = n;
  const o = r === "fixed", s = _e(e), i = a ? Ht(a.floating) : !1;
  if (e === s || i && o)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = we(1);
  const u = we(0), d = be(e);
  if ((d || !d && !o) && ((ze(e) !== "body" || st(s)) && (l = Wt(e)), be(e))) {
    const f = Be(e);
    c = Ke(e), u.x = f.x + e.clientLeft, u.y = f.y + e.clientTop;
  }
  const p = s && !d && !o ? _n(s, l, !0) : we(0);
  return {
    width: t.width * c.x,
    height: t.height * c.y,
    x: t.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: t.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function Xo(n) {
  return Array.from(n.getClientRects());
}
function Go(n) {
  const a = _e(n), t = Wt(n), e = n.ownerDocument.body, r = Ae(a.scrollWidth, a.clientWidth, e.scrollWidth, e.clientWidth), o = Ae(a.scrollHeight, a.clientHeight, e.scrollHeight, e.clientHeight);
  let s = -t.scrollLeft + Dr(n);
  const i = -t.scrollTop;
  return le(e).direction === "rtl" && (s += Ae(a.clientWidth, e.clientWidth) - r), {
    width: r,
    height: o,
    x: s,
    y: i
  };
}
function Zo(n, a) {
  const t = oe(n), e = _e(n), r = t.visualViewport;
  let o = e.clientWidth, s = e.clientHeight, i = 0, l = 0;
  if (r) {
    o = r.width, s = r.height;
    const c = hr();
    (!c || c && a === "fixed") && (i = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: i,
    y: l
  };
}
function Jo(n, a) {
  const t = Be(n, !0, a === "fixed"), e = t.top + n.clientTop, r = t.left + n.clientLeft, o = be(n) ? Ke(n) : we(1), s = n.clientWidth * o.x, i = n.clientHeight * o.y, l = r * o.x, c = e * o.y;
  return {
    width: s,
    height: i,
    x: l,
    y: c
  };
}
function Pr(n, a, t) {
  let e;
  if (a === "viewport")
    e = Zo(n, t);
  else if (a === "document")
    e = Go(_e(n));
  else if (te(a))
    e = Jo(a, t);
  else {
    const r = bn(n);
    e = {
      x: a.x - r.x,
      y: a.y - r.y,
      width: a.width,
      height: a.height
    };
  }
  return Nt(e);
}
function kn(n, a) {
  const t = Re(n);
  return t === a || !te(t) || qe(t) ? !1 : le(t).position === "fixed" || kn(t, a);
}
function es(n, a) {
  const t = a.get(n);
  if (t)
    return t;
  let e = at(n, [], !1).filter((i) => te(i) && ze(i) !== "body"), r = null;
  const o = le(n).position === "fixed";
  let s = o ? Re(n) : n;
  for (; te(s) && !qe(s); ) {
    const i = le(s), l = fr(s);
    !l && i.position === "fixed" && (r = null), (o ? !l && !r : !l && i.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || st(s) && !l && kn(n, s)) ? e = e.filter((u) => u !== s) : r = i, s = Re(s);
  }
  return a.set(n, e), e;
}
function ts(n) {
  let {
    element: a,
    boundary: t,
    rootBoundary: e,
    strategy: r
  } = n;
  const s = [...t === "clippingAncestors" ? Ht(a) ? [] : es(a, this._c) : [].concat(t), e], i = s[0], l = s.reduce((c, u) => {
    const d = Pr(a, u, r);
    return c.top = Ae(d.top, c.top), c.right = $e(d.right, c.right), c.bottom = $e(d.bottom, c.bottom), c.left = Ae(d.left, c.left), c;
  }, Pr(a, i, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function rs(n) {
  const {
    width: a,
    height: t
  } = yn(n);
  return {
    width: a,
    height: t
  };
}
function ns(n, a, t) {
  const e = be(a), r = _e(a), o = t === "fixed", s = Be(n, !0, o, a);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = we(0);
  function c() {
    l.x = Dr(r);
  }
  if (e || !e && !o)
    if ((ze(a) !== "body" || st(r)) && (i = Wt(a)), e) {
      const f = Be(a, !0, o, a);
      l.x = f.x + a.clientLeft, l.y = f.y + a.clientTop;
    } else r && c();
  o && !e && r && c();
  const u = r && !e && !o ? _n(r, i) : we(0), d = s.left + i.scrollLeft - l.x - u.x, p = s.top + i.scrollTop - l.y - u.y;
  return {
    x: d,
    y: p,
    width: s.width,
    height: s.height
  };
}
function Ut(n) {
  return le(n).position === "static";
}
function Tr(n, a) {
  if (!be(n) || le(n).position === "fixed")
    return null;
  if (a)
    return a(n);
  let t = n.offsetParent;
  return _e(n) === t && (t = t.ownerDocument.body), t;
}
function xn(n, a) {
  const t = oe(n);
  if (Ht(n))
    return t;
  if (!be(n)) {
    let r = Re(n);
    for (; r && !qe(r); ) {
      if (te(r) && !Ut(r))
        return r;
      r = Re(r);
    }
    return t;
  }
  let e = Tr(n, a);
  for (; e && xo(e) && Ut(e); )
    e = Tr(e, a);
  return e && qe(e) && Ut(e) && !fr(e) ? t : e || Mo(n) || t;
}
const as = async function(n) {
  const a = this.getOffsetParent || xn, t = this.getDimensions, e = await t(n.floating);
  return {
    reference: ns(n.reference, await a(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      width: e.width,
      height: e.height
    }
  };
};
function os(n) {
  return le(n).direction === "rtl";
}
const ss = {
  convertOffsetParentRelativeRectToViewportRelativeRect: zo,
  getDocumentElement: _e,
  getClippingRect: ts,
  getOffsetParent: xn,
  getElementRects: as,
  getClientRects: Xo,
  getDimensions: rs,
  getScale: Ke,
  isElement: te,
  isRTL: os
};
function Mn(n, a) {
  return n.x === a.x && n.y === a.y && n.width === a.width && n.height === a.height;
}
function is(n, a) {
  let t = null, e;
  const r = _e(n);
  function o() {
    var i;
    clearTimeout(e), (i = t) == null || i.disconnect(), t = null;
  }
  function s(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), o();
    const c = n.getBoundingClientRect(), {
      left: u,
      top: d,
      width: p,
      height: f
    } = c;
    if (i || a(), !p || !f)
      return;
    const h = dt(d), g = dt(r.clientWidth - (u + p)), v = dt(r.clientHeight - (d + f)), D = dt(u), k = {
      rootMargin: -h + "px " + -g + "px " + -v + "px " + -D + "px",
      threshold: Ae(0, $e(1, l)) || 1
    };
    let E = !0;
    function S(N) {
      const w = N[0].intersectionRatio;
      if (w !== l) {
        if (!E)
          return s();
        w ? s(!1, w) : e = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      w === 1 && !Mn(c, n.getBoundingClientRect()) && s(), E = !1;
    }
    try {
      t = new IntersectionObserver(S, {
        ...k,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(S, k);
    }
    t.observe(n);
  }
  return s(!0), o;
}
function ls(n, a, t, e) {
  e === void 0 && (e = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = e, c = gr(n), u = r || o ? [...c ? at(c) : [], ...at(a)] : [];
  u.forEach((D) => {
    r && D.addEventListener("scroll", t, {
      passive: !0
    }), o && D.addEventListener("resize", t);
  });
  const d = c && i ? is(c, t) : null;
  let p = -1, f = null;
  s && (f = new ResizeObserver((D) => {
    let [x] = D;
    x && x.target === c && f && (f.unobserve(a), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var k;
      (k = f) == null || k.observe(a);
    })), t();
  }), c && !l && f.observe(c), f.observe(a));
  let h, g = l ? Be(n) : null;
  l && v();
  function v() {
    const D = Be(n);
    g && !Mn(g, D) && t(), g = D, h = requestAnimationFrame(v);
  }
  return t(), () => {
    var D;
    u.forEach((x) => {
      r && x.removeEventListener("scroll", t), o && x.removeEventListener("resize", t);
    }), d == null || d(), (D = f) == null || D.disconnect(), f = null, l && cancelAnimationFrame(h);
  };
}
const cs = qo, us = Vo, Or = Ko, ds = (n, a, t) => {
  const e = /* @__PURE__ */ new Map(), r = {
    platform: ss,
    ...t
  }, o = {
    ...r.platform,
    _c: e
  };
  return Bo(n, a, {
    ...r,
    platform: o
  });
};
var ps = typeof document < "u", fs = function() {
}, yt = ps ? en : fs;
function Yt(n, a) {
  if (n === a)
    return !0;
  if (typeof n != typeof a)
    return !1;
  if (typeof n == "function" && n.toString() === a.toString())
    return !0;
  let t, e, r;
  if (n && a && typeof n == "object") {
    if (Array.isArray(n)) {
      if (t = n.length, t !== a.length) return !1;
      for (e = t; e-- !== 0; )
        if (!Yt(n[e], a[e]))
          return !1;
      return !0;
    }
    if (r = Object.keys(n), t = r.length, t !== Object.keys(a).length)
      return !1;
    for (e = t; e-- !== 0; )
      if (!{}.hasOwnProperty.call(a, r[e]))
        return !1;
    for (e = t; e-- !== 0; ) {
      const o = r[e];
      if (!(o === "_owner" && n.$$typeof) && !Yt(n[o], a[o]))
        return !1;
    }
    return !0;
  }
  return n !== n && a !== a;
}
function Cn(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Nr(n, a) {
  const t = Cn(n);
  return Math.round(a * t) / t;
}
function qt(n) {
  const a = T.useRef(n);
  return yt(() => {
    a.current = n;
  }), a;
}
function hs(n) {
  n === void 0 && (n = {});
  const {
    placement: a = "bottom",
    strategy: t = "absolute",
    middleware: e = [],
    platform: r,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: l,
    open: c
  } = n, [u, d] = T.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: a,
    middlewareData: {},
    isPositioned: !1
  }), [p, f] = T.useState(e);
  Yt(p, e) || f(e);
  const [h, g] = T.useState(null), [v, D] = T.useState(null), x = T.useCallback((O) => {
    O !== N.current && (N.current = O, g(O));
  }, []), k = T.useCallback((O) => {
    O !== w.current && (w.current = O, D(O));
  }, []), E = o || h, S = s || v, N = T.useRef(null), w = T.useRef(null), _ = T.useRef(u), C = l != null, I = qt(l), W = qt(r), A = qt(c), K = T.useCallback(() => {
    if (!N.current || !w.current)
      return;
    const O = {
      placement: a,
      strategy: t,
      middleware: p
    };
    W.current && (O.platform = W.current), ds(N.current, w.current, O).then((X) => {
      const ce = {
        ...X,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: A.current !== !1
      };
      V.current && !Yt(_.current, ce) && (_.current = ce, Xn.flushSync(() => {
        d(ce);
      }));
    });
  }, [p, a, t, W, A]);
  yt(() => {
    c === !1 && _.current.isPositioned && (_.current.isPositioned = !1, d((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [c]);
  const V = T.useRef(!1);
  yt(() => (V.current = !0, () => {
    V.current = !1;
  }), []), yt(() => {
    if (E && (N.current = E), S && (w.current = S), E && S) {
      if (I.current)
        return I.current(E, S, K);
      K();
    }
  }, [E, S, K, I, C]);
  const B = T.useMemo(() => ({
    reference: N,
    floating: w,
    setReference: x,
    setFloating: k
  }), [x, k]), P = T.useMemo(() => ({
    reference: E,
    floating: S
  }), [E, S]), R = T.useMemo(() => {
    const O = {
      position: t,
      left: 0,
      top: 0
    };
    if (!P.floating)
      return O;
    const X = Nr(P.floating, u.x), ce = Nr(P.floating, u.y);
    return i ? {
      ...O,
      transform: "translate(" + X + "px, " + ce + "px)",
      ...Cn(P.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: X,
      top: ce
    };
  }, [t, i, P.floating, u.x, u.y]);
  return T.useMemo(() => ({
    ...u,
    update: K,
    refs: B,
    elements: P,
    floatingStyles: R
  }), [u, K, B, P, R]);
}
const ms = (n) => {
  function a(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: n,
    fn(t) {
      const {
        element: e,
        padding: r
      } = typeof n == "function" ? n(t) : n;
      return e && a(e) ? e.current != null ? Or({
        element: e.current,
        padding: r
      }).fn(t) : {} : e ? Or({
        element: e,
        padding: r
      }).fn(t) : {};
    }
  };
}, vs = (n, a) => ({
  ...cs(n),
  options: [n, a]
}), gs = (n, a) => ({
  ...us(n),
  options: [n, a]
}), Ds = (n, a) => ({
  ...ms(n),
  options: [n, a]
}), ws = {
  ...T
};
let Rr = !1, ys = 0;
const Yr = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + ys++
);
function bs() {
  const [n, a] = T.useState(() => Rr ? Yr() : void 0);
  return Rt(() => {
    n == null && a(Yr());
  }, []), T.useEffect(() => {
    Rr = !0;
  }, []), n;
}
const _s = ws.useId, Sn = _s || bs;
let ot;
process.env.NODE_ENV !== "production" && (ot = /* @__PURE__ */ new Set());
function ks() {
  for (var n, a = arguments.length, t = new Array(a), e = 0; e < a; e++)
    t[e] = arguments[e];
  const r = "Floating UI: " + t.join(" ");
  if (!((n = ot) != null && n.has(r))) {
    var o;
    (o = ot) == null || o.add(r), console.warn(r);
  }
}
function xs() {
  for (var n, a = arguments.length, t = new Array(a), e = 0; e < a; e++)
    t[e] = arguments[e];
  const r = "Floating UI: " + t.join(" ");
  if (!((n = ot) != null && n.has(r))) {
    var o;
    (o = ot) == null || o.add(r), console.error(r);
  }
}
const Ms = /* @__PURE__ */ T.forwardRef(function(a, t) {
  const {
    context: {
      placement: e,
      elements: {
        floating: r
      },
      middlewareData: {
        arrow: o,
        shift: s
      }
    },
    width: i = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: u = 0,
    staticOffset: d,
    stroke: p,
    d: f,
    style: {
      transform: h,
      ...g
    } = {},
    ...v
  } = a;
  process.env.NODE_ENV !== "production" && (t || ks("The `ref` prop is required for `FloatingArrow`."));
  const D = Sn(), [x, k] = T.useState(!1);
  if (Rt(() => {
    if (!r) return;
    le(r).direction === "rtl" && k(!0);
  }, [r]), !r)
    return null;
  const [E, S] = e.split("-"), N = E === "top" || E === "bottom";
  let w = d;
  (N && s != null && s.x || !N && s != null && s.y) && (w = null);
  const _ = u * 2, C = _ / 2, I = i / 2 * (c / -8 + 1), W = l / 2 * c / 4, A = !!f, K = w && S === "end" ? "bottom" : "top";
  let V = w && S === "end" ? "right" : "left";
  w && x && (V = S === "end" ? "left" : "right");
  const B = (o == null ? void 0 : o.x) != null ? w || o.x : "", P = (o == null ? void 0 : o.y) != null ? w || o.y : "", R = f || "M0,0" + (" H" + i) + (" L" + (i - I) + "," + (l - W)) + (" Q" + i / 2 + "," + l + " " + I + "," + (l - W)) + " Z", O = {
    top: A ? "rotate(180deg)" : "",
    left: A ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: A ? "" : "rotate(180deg)",
    right: A ? "rotate(-90deg)" : "rotate(90deg)"
  }[E];
  return /* @__PURE__ */ Jr("svg", {
    ...v,
    "aria-hidden": !0,
    ref: t,
    width: A ? i : i + _,
    height: i,
    viewBox: "0 0 " + i + " " + (l > i ? l : i),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [V]: B,
      [K]: P,
      [E]: N || A ? "100%" : "calc(100% - " + _ / 2 + "px)",
      transform: [O, h].filter((X) => !!X).join(" "),
      ...g
    },
    children: [_ > 0 && /* @__PURE__ */ Se("path", {
      clipPath: "url(#" + D + ")",
      fill: "none",
      stroke: p,
      strokeWidth: _ + (f ? 0 : 1),
      d: R
    }), /* @__PURE__ */ Se("path", {
      stroke: _ && !f ? v.fill : "none",
      d: R
    }), /* @__PURE__ */ Se("clipPath", {
      id: D,
      children: /* @__PURE__ */ Se("rect", {
        x: -C,
        y: C * (A ? -1 : 1),
        width: i + _,
        height: i
      })
    })]
  });
});
function Cs() {
  const n = /* @__PURE__ */ new Map();
  return {
    emit(a, t) {
      var e;
      (e = n.get(a)) == null || e.forEach((r) => r(t));
    },
    on(a, t) {
      n.has(a) || n.set(a, /* @__PURE__ */ new Set()), n.get(a).add(t);
    },
    off(a, t) {
      var e;
      (e = n.get(a)) == null || e.delete(t);
    }
  };
}
const Ss = /* @__PURE__ */ T.createContext(null), Es = /* @__PURE__ */ T.createContext(null), Ps = () => {
  var n;
  return ((n = T.useContext(Ss)) == null ? void 0 : n.id) || null;
}, Ts = () => T.useContext(Es);
function Os(n) {
  const {
    open: a = !1,
    onOpenChange: t,
    elements: e
  } = n, r = Sn(), o = T.useRef({}), [s] = T.useState(() => Cs()), i = Ps() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = e.reference;
    f && !te(f) && xs("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = T.useState(e.reference), u = Wo((f, h, g) => {
    o.current.openEvent = f ? h : void 0, s.emit("openchange", {
      open: f,
      event: h,
      reason: g,
      nested: i
    }), t == null || t(f, h, g);
  }), d = T.useMemo(() => ({
    setPositionReference: c
  }), []), p = T.useMemo(() => ({
    reference: l || e.reference || null,
    floating: e.floating || null,
    domReference: e.reference
  }), [l, e.reference, e.floating]);
  return T.useMemo(() => ({
    dataRef: o,
    open: a,
    onOpenChange: u,
    elements: p,
    events: s,
    floatingId: r,
    refs: d
  }), [a, u, p, s, r, d]);
}
function Ns(n) {
  n === void 0 && (n = {});
  const {
    nodeId: a
  } = n, t = Os({
    ...n,
    elements: {
      reference: null,
      floating: null,
      ...n.elements
    }
  }), e = n.rootContext || t, r = e.elements, [o, s] = T.useState(null), [i, l] = T.useState(null), u = (r == null ? void 0 : r.domReference) || o, d = T.useRef(null), p = Ts();
  Rt(() => {
    u && (d.current = u);
  }, [u]);
  const f = hs({
    ...n,
    elements: {
      ...r,
      ...i && {
        reference: i
      }
    }
  }), h = T.useCallback((k) => {
    const E = te(k) ? {
      getBoundingClientRect: () => k.getBoundingClientRect(),
      getClientRects: () => k.getClientRects(),
      contextElement: k
    } : k;
    l(E), f.refs.setReference(E);
  }, [f.refs]), g = T.useCallback((k) => {
    (te(k) || k === null) && (d.current = k, s(k)), (te(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    k !== null && !te(k)) && f.refs.setReference(k);
  }, [f.refs]), v = T.useMemo(() => ({
    ...f.refs,
    setReference: g,
    setPositionReference: h,
    domReference: d
  }), [f.refs, g, h]), D = T.useMemo(() => ({
    ...f.elements,
    domReference: u
  }), [f.elements, u]), x = T.useMemo(() => ({
    ...f,
    ...e,
    refs: v,
    elements: D,
    nodeId: a
  }), [f, v, D, a, e]);
  return Rt(() => {
    e.dataRef.current.floatingContext = x;
    const k = p == null ? void 0 : p.nodesRef.current.find((E) => E.id === a);
    k && (k.context = x);
  }), T.useMemo(() => ({
    ...f,
    context: x,
    refs: v,
    elements: D
  }), [f, v, D, x]);
}
/*!
  react-datepicker v7.6.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var sr = function(a, t) {
  return sr = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }, sr(a, t);
};
function J(n, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
  sr(n, a);
  function t() {
    this.constructor = n;
  }
  n.prototype = a === null ? Object.create(a) : (t.prototype = a.prototype, new t());
}
var F = function() {
  return F = Object.assign || function(t) {
    for (var e, r = 1, o = arguments.length; r < o; r++) {
      e = arguments[r];
      for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    }
    return t;
  }, F.apply(this, arguments);
};
function me(n, a, t) {
  if (t || arguments.length === 2) for (var e = 0, r = a.length, o; e < r; e++)
    (o || !(e in a)) && (o || (o = Array.prototype.slice.call(a, 0, e)), o[e] = a[e]);
  return n.concat(o || Array.prototype.slice.call(a));
}
var Rs = function(n) {
  var a = n.showTimeSelectOnly, t = a === void 0 ? !1 : a, e = n.showTime, r = e === void 0 ? !1 : e, o = n.className, s = n.children, i = t ? "Choose Time" : "Choose Date".concat(r ? " and Time" : "");
  return m.createElement("div", { className: o, role: "dialog", "aria-label": i, "aria-modal": "true" }, s);
}, Ys = function(n, a) {
  var t = kt(null), e = kt(n);
  e.current = n;
  var r = An(function(o) {
    var s;
    t.current && !t.current.contains(o.target) && (a && o.target instanceof HTMLElement && o.target.classList.contains(a) || (s = e.current) === null || s === void 0 || s.call(e, o));
  }, [a]);
  return Hn(function() {
    return document.addEventListener("mousedown", r), function() {
      document.removeEventListener("mousedown", r);
    };
  }, [r]), t;
}, Qt = function(n) {
  var a = n.children, t = n.onClickOutside, e = n.className, r = n.containerRef, o = n.style, s = n.ignoreClass, i = Ys(t, s);
  return m.createElement("div", { className: e, style: o, ref: function(l) {
    i.current = l, r && (r.current = l);
  } }, a);
}, y;
(function(n) {
  n.ArrowUp = "ArrowUp", n.ArrowDown = "ArrowDown", n.ArrowLeft = "ArrowLeft", n.ArrowRight = "ArrowRight", n.PageUp = "PageUp", n.PageDown = "PageDown", n.Home = "Home", n.End = "End", n.Enter = "Enter", n.Space = " ", n.Tab = "Tab", n.Escape = "Escape", n.Backspace = "Backspace", n.X = "x";
})(y || (y = {}));
function En() {
  var n = typeof window < "u" ? window : globalThis;
  return n;
}
var lt = 12, Is = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Q(n) {
  if (n == null)
    return /* @__PURE__ */ new Date();
  var a = typeof n == "string" ? so(n) : M(n);
  return ke(a) ? a : /* @__PURE__ */ new Date();
}
function $t(n, a, t, e, r) {
  var o, s = null, i = He(t) || He(et()), l = !0;
  if (Array.isArray(a))
    return a.forEach(function(u) {
      var d = Kt(n, u, /* @__PURE__ */ new Date(), {
        locale: i,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      e && (l = ke(d, r) && n === U(d, u, t)), ke(d, r) && l && (s = d);
    }), s;
  if (s = Kt(n, a, /* @__PURE__ */ new Date(), {
    locale: i,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), e)
    l = ke(s) && n === U(s, a, t);
  else if (!ke(s)) {
    var c = ((o = a.match(Is)) !== null && o !== void 0 ? o : []).map(function(u) {
      var d = u[0];
      if (d === "p" || d === "P") {
        var p = Zt[d];
        return i ? p(u, i.formatLong) : d;
      }
      return u;
    }).join("");
    n.length > 0 && (s = Kt(n, c.slice(0, n.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), ke(s) || (s = new Date(n));
  }
  return ke(s) && l ? s : null;
}
function ke(n, a) {
  return Jt(n) && !We(n, a ?? /* @__PURE__ */ new Date("1/1/1800"));
}
function U(n, a, t) {
  if (t === "en")
    return er(n, a, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var e = t ? He(t) : void 0;
  return t && !e && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !e && et() && He(et()) && (e = He(et())), er(n, a, {
    locale: e,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function se(n, a) {
  var t = a.dateFormat, e = a.locale, r = Array.isArray(t) && t.length > 0 ? t[0] : t;
  return n && U(n, r, e) || "";
}
function Ls(n, a, t) {
  if (!n)
    return "";
  var e = se(n, t), r = a ? se(a, t) : "";
  return "".concat(e, " - ").concat(r);
}
function Fs(n, a) {
  if (!(n != null && n.length))
    return "";
  var t = n[0] ? se(n[0], a) : "";
  if (n.length === 1)
    return t;
  if (n.length === 2 && n[1]) {
    var e = se(n[1], a);
    return "".concat(t, ", ").concat(e);
  }
  var r = n.length - 1;
  return "".concat(t, " (+").concat(r, ")");
}
function jt(n, a) {
  var t = a.hour, e = t === void 0 ? 0 : t, r = a.minute, o = r === void 0 ? 0 : r, s = a.second, i = s === void 0 ? 0 : s;
  return gt(Dt(wt(n, i), o), e);
}
function As(n) {
  return nn(n);
}
function Hs(n, a) {
  return U(n, "ddd", a);
}
function bt(n) {
  return tt(n);
}
function Te(n, a, t) {
  var e = He(a || et());
  return xt(n, {
    locale: e,
    weekStartsOn: t
  });
}
function Ce(n) {
  return ln(n);
}
function Ze(n) {
  return lr(n);
}
function Ir(n) {
  return rr(n);
}
function Lr() {
  return tt(Q());
}
function Fr(n) {
  return on(n);
}
function Ws(n) {
  return na(n);
}
function Bs(n) {
  return sn(n);
}
function pe(n, a) {
  return n && a ? oo(n, a) : !n && !a;
}
function re(n, a) {
  return n && a ? no(n, a) : !n && !a;
}
function It(n, a) {
  return n && a ? ao(n, a) : !n && !a;
}
function L(n, a) {
  return n && a ? ta(n, a) : !n && !a;
}
function Ie(n, a) {
  return n && a ? la(n, a) : !n && !a;
}
function Je(n, a, t) {
  var e, r = tt(a), o = on(t);
  try {
    e = nt(n, { start: r, end: o });
  } catch {
    e = !1;
  }
  return e;
}
function et() {
  var n = En();
  return n.__localeId__;
}
function He(n) {
  if (typeof n == "string") {
    var a = En();
    return a.__localeData__ ? a.__localeData__[n] : void 0;
  } else
    return n;
}
function Qs(n, a, t) {
  return a(U(n, "EEEE", t));
}
function Ks(n, a) {
  return U(n, "EEEEEE", a);
}
function Vs(n, a) {
  return U(n, "EEE", a);
}
function wr(n, a) {
  return U(ae(Q(), n), "LLLL", a);
}
function Pn(n, a) {
  return U(ae(Q(), n), "LLL", a);
}
function Us(n, a) {
  return U(Qe(Q(), n), "QQQ", a);
}
function ie(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.excludeDateIntervals, i = t.includeDates, l = t.includeDateIntervals, c = t.filterDate;
  return ct(n, { minDate: e, maxDate: r }) || o && o.some(function(u) {
    return u instanceof Date ? L(n, u) : L(n, u.date);
  }) || s && s.some(function(u) {
    var d = u.start, p = u.end;
    return nt(n, { start: d, end: p });
  }) || i && !i.some(function(u) {
    return L(n, u);
  }) || l && !l.some(function(u) {
    var d = u.start, p = u.end;
    return nt(n, { start: d, end: p });
  }) || c && !c(Q(n)) || !1;
}
function yr(n, a) {
  var t = a === void 0 ? {} : a, e = t.excludeDates, r = t.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(o) {
    var s = o.start, i = o.end;
    return nt(n, { start: s, end: i });
  }) : e && e.some(function(o) {
    var s;
    return o instanceof Date ? L(n, o) : L(n, (s = o.date) !== null && s !== void 0 ? s : /* @__PURE__ */ new Date());
  }) || !1;
}
function Tn(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate;
  return ct(n, {
    minDate: e ? ln(e) : void 0,
    maxDate: r ? sn(r) : void 0
  }) || (o == null ? void 0 : o.some(function(l) {
    return re(n, l instanceof Date ? l : l.date);
  })) || s && !s.some(function(l) {
    return re(n, l);
  }) || i && !i(Q(n)) || !1;
}
function pt(n, a, t, e) {
  var r = Y(n), o = ne(n), s = Y(a), i = ne(a), l = Y(e);
  return r === s && r === l ? o <= t && t <= i : r < s ? l === r && o <= t || l === s && i >= t || l < s && l > r : !1;
}
function qs(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates;
  return ct(n, { minDate: e, maxDate: r }) || o && o.some(function(i) {
    return re(i instanceof Date ? i : i.date, n);
  }) || s && !s.some(function(i) {
    return re(i, n);
  }) || !1;
}
function ft(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate;
  return ct(n, { minDate: e, maxDate: r }) || (o == null ? void 0 : o.some(function(l) {
    return It(n, l instanceof Date ? l : l.date);
  })) || s && !s.some(function(l) {
    return It(n, l);
  }) || i && !i(Q(n)) || !1;
}
function ht(n, a, t) {
  if (!a || !t || !Jt(a) || !Jt(t))
    return !1;
  var e = Y(a), r = Y(t);
  return e <= n && r >= n;
}
function _t(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate, l = new Date(n, 0, 1);
  return ct(l, {
    minDate: e ? lr(e) : void 0,
    maxDate: r ? cn(r) : void 0
  }) || (o == null ? void 0 : o.some(function(c) {
    return pe(l, c instanceof Date ? c : c.date);
  })) || s && !s.some(function(c) {
    return pe(l, c);
  }) || i && !i(Q(l)) || !1;
}
function mt(n, a, t, e) {
  var r = Y(n), o = Fe(n), s = Y(a), i = Fe(a), l = Y(e);
  return r === s && r === l ? o <= t && t <= i : r < s ? l === r && o <= t || l === s && i >= t || l < s && l > r : !1;
}
function ct(n, a) {
  var t, e = a === void 0 ? {} : a, r = e.minDate, o = e.maxDate;
  return (t = r && rt(n, r) < 0 || o && rt(n, o) > 0) !== null && t !== void 0 ? t : !1;
}
function Ar(n, a) {
  return a.some(function(t) {
    return ge(t) === ge(n) && De(t) === De(n) && Me(t) === Me(n);
  });
}
function Hr(n, a) {
  var t = a === void 0 ? {} : a, e = t.excludeTimes, r = t.includeTimes, o = t.filterTime;
  return e && Ar(n, e) || r && !Ar(n, r) || o && !o(n) || !1;
}
function Wr(n, a) {
  var t = a.minTime, e = a.maxTime;
  if (!t || !e)
    throw new Error("Both minTime and maxTime props required");
  var r = Q();
  r = gt(r, ge(n)), r = Dt(r, De(n)), r = wt(r, Me(n));
  var o = Q();
  o = gt(o, ge(t)), o = Dt(o, De(t)), o = wt(o, Me(t));
  var s = Q();
  s = gt(s, ge(e)), s = Dt(s, De(e)), s = wt(s, Me(e));
  var i;
  try {
    i = !nt(r, { start: o, end: s });
  } catch {
    i = !1;
  }
  return i;
}
function Br(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.includeDates, o = Le(n, 1);
  return e && Ct(e, o) > 0 || r && r.every(function(s) {
    return Ct(s, o) > 0;
  }) || !1;
}
function Qr(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.includeDates, o = ye(n, 1);
  return e && Ct(o, e) > 0 || r && r.every(function(s) {
    return Ct(o, s) > 0;
  }) || !1;
}
function $s(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.includeDates, o = lr(n), s = mn(o);
  return e && St(e, s) > 0 || r && r.every(function(i) {
    return St(i, s) > 0;
  }) || !1;
}
function js(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.includeDates, o = cn(n), s = ur(o, 1);
  return e && St(s, e) > 0 || r && r.every(function(i) {
    return St(s, i) > 0;
  }) || !1;
}
function Kr(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.includeDates, o = Ue(n, 1);
  return e && Et(e, o) > 0 || r && r.every(function(s) {
    return Et(s, o) > 0;
  }) || !1;
}
function zs(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.yearItemNumber, o = r === void 0 ? lt : r, s = Ze(Ue(n, o)), i = Ee(s, o).endPeriod, l = e && Y(e);
  return l && l > i || !1;
}
function Vr(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.includeDates, o = xe(n, 1);
  return e && Et(o, e) > 0 || r && r.every(function(s) {
    return Et(o, s) > 0;
  }) || !1;
}
function Xs(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.yearItemNumber, o = r === void 0 ? lt : r, s = xe(n, o), i = Ee(s, o).startPeriod, l = e && Y(e);
  return l && l < i || !1;
}
function On(n) {
  var a = n.minDate, t = n.includeDates;
  if (t && a) {
    var e = t.filter(function(r) {
      return rt(r, a) >= 0;
    });
    return kr(e);
  } else return t ? kr(t) : a;
}
function Nn(n) {
  var a = n.maxDate, t = n.includeDates;
  if (t && a) {
    var e = t.filter(function(r) {
      return rt(r, a) <= 0;
    });
    return _r(e);
  } else return t ? _r(t) : a;
}
function Ur(n, a) {
  var t;
  n === void 0 && (n = []), a === void 0 && (a = "react-datepicker__day--highlighted");
  for (var e = /* @__PURE__ */ new Map(), r = 0, o = n.length; r < o; r++) {
    var s = n[r];
    if (Pe(s)) {
      var i = U(s, "MM.dd.yyyy"), l = e.get(i) || [];
      l.includes(a) || (l.push(a), e.set(i, l));
    } else if (typeof s == "object") {
      var c = Object.keys(s), u = (t = c[0]) !== null && t !== void 0 ? t : "", d = s[u];
      if (typeof u == "string" && Array.isArray(d))
        for (var p = 0, f = d.length; p < f; p++) {
          var h = d[p];
          if (h) {
            var i = U(h, "MM.dd.yyyy"), l = e.get(i) || [];
            l.includes(u) || (l.push(u), e.set(i, l));
          }
        }
    }
  }
  return e;
}
function Gs(n, a) {
  return n.length !== a.length ? !1 : n.every(function(t, e) {
    return t === a[e];
  });
}
function Zs(n, a) {
  n === void 0 && (n = []), a === void 0 && (a = "react-datepicker__day--holidays");
  var t = /* @__PURE__ */ new Map();
  return n.forEach(function(e) {
    var r = e.date, o = e.holidayName;
    if (Pe(r)) {
      var s = U(r, "MM.dd.yyyy"), i = t.get(s) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in i && i.className === a && Gs(i.holidayNames, [o]))) {
        i.className = a;
        var l = i.holidayNames;
        i.holidayNames = l ? me(me([], l, !0), [o], !1) : [o], t.set(s, i);
      }
    }
  }), t;
}
function Js(n, a, t, e, r) {
  for (var o = r.length, s = [], i = 0; i < o; i++) {
    var l = n, c = r[i];
    c && (l = Jn(l, ge(c)), l = tr(l, De(c)), l = ea(l, Me(c)));
    var u = tr(n, (t + 1) * e);
    Ne(l, a) && We(l, u) && c != null && s.push(c);
  }
  return s;
}
function qr(n) {
  return n < 10 ? "0".concat(n) : "".concat(n);
}
function Ee(n, a) {
  a === void 0 && (a = lt);
  var t = Math.ceil(Y(n) / a) * a, e = t - (a - 1);
  return { startPeriod: e, endPeriod: t };
}
function ei(n) {
  var a = new Date(n.getFullYear(), n.getMonth(), n.getDate()), t = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 24);
  return Math.round((+t - +a) / 36e5);
}
function $r(n) {
  var a = n.getSeconds(), t = n.getMilliseconds();
  return M(n.getTime() - a * 1e3 - t);
}
function ti(n, a) {
  return $r(n).getTime() === $r(a).getTime();
}
function jr(n) {
  if (!Pe(n))
    throw new Error("Invalid date");
  var a = new Date(n);
  return a.setHours(0, 0, 0, 0), a;
}
function zr(n, a) {
  if (!Pe(n) || !Pe(a))
    throw new Error("Invalid date received");
  var t = jr(n), e = jr(a);
  return We(t, e);
}
function Rn(n) {
  return n.key === y.Space;
}
var ri = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.inputRef = m.createRef(), e.onTimeChange = function(r) {
        var o, s;
        e.setState({ time: r });
        var i = e.props.date, l = i instanceof Date && !isNaN(+i), c = l ? i : /* @__PURE__ */ new Date();
        if (r != null && r.includes(":")) {
          var u = r.split(":"), d = u[0], p = u[1];
          c.setHours(Number(d)), c.setMinutes(Number(p));
        }
        (s = (o = e.props).onChange) === null || s === void 0 || s.call(o, c);
      }, e.renderTimeInput = function() {
        var r = e.state.time, o = e.props, s = o.date, i = o.timeString, l = o.customTimeInput;
        return l ? tn(l, {
          date: s,
          value: r,
          onChange: e.onTimeChange
        }) : m.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: e.inputRef, onClick: function() {
          var c;
          (c = e.inputRef.current) === null || c === void 0 || c.focus();
        }, required: !0, value: r, onChange: function(c) {
          e.onTimeChange(c.target.value || i);
        } });
      }, e.state = {
        time: e.props.timeString
      }, e;
    }
    return a.getDerivedStateFromProps = function(t, e) {
      return t.timeString !== e.time ? {
        time: t.timeString
      } : null;
    }, a.prototype.render = function() {
      return m.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        m.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        m.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          m.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, a;
  }(Z)
), ni = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.dayEl = Oe(), t.handleClick = function(e) {
        !t.isDisabled() && t.props.onClick && t.props.onClick(e);
      }, t.handleMouseEnter = function(e) {
        !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(e);
      }, t.handleOnKeyDown = function(e) {
        var r, o, s = e.key;
        s === y.Space && (e.preventDefault(), e.key = y.Enter), (o = (r = t.props).handleOnKeyDown) === null || o === void 0 || o.call(r, e);
      }, t.isSameDay = function(e) {
        return L(t.props.day, e);
      }, t.isKeyboardSelected = function() {
        var e;
        if (t.props.disabledKeyboardNavigation)
          return !1;
        var r = t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(s) {
          return t.isSameDayOrWeek(s);
        }) : t.isSameDayOrWeek(t.props.selected), o = t.props.preSelection && t.isDisabled(t.props.preSelection);
        return !r && t.isSameDayOrWeek(t.props.preSelection) && !o;
      }, t.isDisabled = function(e) {
        return e === void 0 && (e = t.props.day), ie(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function() {
        return yr(t.props.day, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.isStartOfWeek = function() {
        return L(t.props.day, Te(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameWeek = function(e) {
        return t.props.showWeekPicker && L(e, Te(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameDayOrWeek = function(e) {
        return t.isSameDay(e) || t.isSameWeek(e);
      }, t.getHighLightedClass = function() {
        var e = t.props, r = e.day, o = e.highlightDates;
        if (!o)
          return !1;
        var s = U(r, "MM.dd.yyyy");
        return o.get(s);
      }, t.getHolidaysClass = function() {
        var e, r = t.props, o = r.day, s = r.holidays;
        if (!s)
          return [void 0];
        var i = U(o, "MM.dd.yyyy");
        return s.has(i) ? [(e = s.get(i)) === null || e === void 0 ? void 0 : e.className] : [void 0];
      }, t.isInRange = function() {
        var e = t.props, r = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : Je(r, o, s);
      }, t.isInSelectingRange = function() {
        var e, r = t.props, o = r.day, s = r.selectsStart, i = r.selectsEnd, l = r.selectsRange, c = r.selectsDisabledDaysInRange, u = r.startDate, d = r.endDate, p = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return !(s || i || l) || !p || !c && t.isDisabled() ? !1 : s && d && (We(p, d) || Ie(p, d)) ? Je(o, p, d) : i && u && (Ne(p, u) || Ie(p, u)) || l && u && !d && (Ne(p, u) || Ie(p, u)) ? Je(o, u, p) : !1;
      }, t.isSelectingRangeStart = function() {
        var e;
        if (!t.isInSelectingRange())
          return !1;
        var r = t.props, o = r.day, s = r.startDate, i = r.selectsStart, l = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return i ? L(o, l) : L(o, s);
      }, t.isSelectingRangeEnd = function() {
        var e;
        if (!t.isInSelectingRange())
          return !1;
        var r = t.props, o = r.day, s = r.endDate, i = r.selectsEnd, l = r.selectsRange, c = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return i || l ? L(o, c) : L(o, s);
      }, t.isRangeStart = function() {
        var e = t.props, r = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : L(o, r);
      }, t.isRangeEnd = function() {
        var e = t.props, r = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : L(s, r);
      }, t.isWeekend = function() {
        var e = aa(t.props.day);
        return e === 0 || e === 6;
      }, t.isAfterMonth = function() {
        return t.props.month !== void 0 && (t.props.month + 1) % 12 === ne(t.props.day);
      }, t.isBeforeMonth = function() {
        return t.props.month !== void 0 && (ne(t.props.day) + 1) % 12 === t.props.month;
      }, t.isCurrentDay = function() {
        return t.isSameDay(Q());
      }, t.isSelected = function() {
        var e;
        return t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(r) {
          return t.isSameDayOrWeek(r);
        }) : t.isSameDayOrWeek(t.props.selected);
      }, t.getClassNames = function(e) {
        var r = t.props.dayClassName ? t.props.dayClassName(e) : void 0;
        return ee("react-datepicker__day", r, "react-datepicker__day--" + Hs(t.props.day), {
          "react-datepicker__day--disabled": t.isDisabled(),
          "react-datepicker__day--excluded": t.isExcluded(),
          "react-datepicker__day--selected": t.isSelected(),
          "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
          "react-datepicker__day--range-start": t.isRangeStart(),
          "react-datepicker__day--range-end": t.isRangeEnd(),
          "react-datepicker__day--in-range": t.isInRange(),
          "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
          "react-datepicker__day--today": t.isCurrentDay(),
          "react-datepicker__day--weekend": t.isWeekend(),
          "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
        }, t.getHighLightedClass(), t.getHolidaysClass());
      }, t.getAriaLabel = function() {
        var e = t.props, r = e.day, o = e.ariaLabelPrefixWhenEnabled, s = o === void 0 ? "Choose" : o, i = e.ariaLabelPrefixWhenDisabled, l = i === void 0 ? "Not available" : i, c = t.isDisabled() || t.isExcluded() ? l : s;
        return "".concat(c, " ").concat(U(r, "PPPP", t.props.locale));
      }, t.getTitle = function() {
        var e = t.props, r = e.day, o = e.holidays, s = o === void 0 ? /* @__PURE__ */ new Map() : o, i = e.excludeDates, l = U(r, "MM.dd.yyyy"), c = [];
        return s.has(l) && c.push.apply(c, s.get(l).holidayNames), t.isExcluded() && c.push(i == null ? void 0 : i.filter(function(u) {
          return u instanceof Date ? L(u, r) : L(u == null ? void 0 : u.date, r);
        }).map(function(u) {
          if (!(u instanceof Date))
            return u == null ? void 0 : u.message;
        })), c.join(", ");
      }, t.getTabIndex = function() {
        var e = t.props.selected, r = t.props.preSelection, o = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(e) && L(r, e)) ? 0 : -1;
        return o;
      }, t.handleFocusDay = function() {
        var e;
        t.shouldFocusDay() && ((e = t.dayEl.current) === null || e === void 0 || e.focus({ preventScroll: !0 }));
      }, t.renderDayContents = function() {
        return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(Mr(t.props.day), t.props.day) : Mr(t.props.day);
      }, t.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          m.createElement(
            "div",
            { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter, onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() },
            t.renderDayContents(),
            t.getTitle() !== "" && m.createElement("span", { className: "overlay" }, t.getTitle())
          )
        );
      }, t;
    }
    return a.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, a.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, a.prototype.shouldFocusDay = function() {
      var t = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (t = !0), this.props.inline && !this.props.shouldFocusDayInline && (t = !1), this.isDayActiveElement() && (t = !0), this.isDuplicateDay() && (t = !1)), t;
    }, a.prototype.isDayActiveElement = function() {
      var t, e, r;
      return ((e = (t = this.props.containerRef) === null || t === void 0 ? void 0 : t.current) === null || e === void 0 ? void 0 : e.contains(document.activeElement)) && ((r = document.activeElement) === null || r === void 0 ? void 0 : r.classList.contains("react-datepicker__day"));
    }, a.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, a;
  }(Z)
), ai = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.weekNumberEl = Oe(), t.handleClick = function(e) {
        t.props.onClick && t.props.onClick(e);
      }, t.handleOnKeyDown = function(e) {
        var r, o, s = e.key;
        s === y.Space && (e.preventDefault(), e.key = y.Enter), (o = (r = t.props).handleOnKeyDown) === null || o === void 0 || o.call(r, e);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !L(t.props.date, t.props.selected) && L(t.props.date, t.props.preSelection);
      }, t.getTabIndex = function() {
        return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || L(t.props.date, t.props.selected) && L(t.props.preSelection, t.props.selected)) ? 0 : -1;
      }, t.handleFocusWeekNumber = function(e) {
        var r = !1;
        t.getTabIndex() === 0 && !(e != null && e.isInputFocused) && L(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (r = !0), t.props.inline && !t.props.shouldFocusDayInline && (r = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, a.prototype.componentDidUpdate = function(t) {
      this.handleFocusWeekNumber(t);
    }, a.prototype.render = function() {
      var t = this.props, e = t.weekNumber, r = t.isWeekDisabled, o = t.ariaLabelPrefix, s = o === void 0 ? a.defaultProps.ariaLabelPrefix : o, i = t.onClick, l = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!i && !r,
        "react-datepicker__week-number--selected": !!i && L(this.props.date, this.props.selected)
      };
      return m.createElement("div", { ref: this.weekNumberEl, className: ee(l), "aria-label": "".concat(s, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, e);
    }, a;
  }(Z)
), oi = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.isDisabled = function(e) {
        return ie(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.handleDayClick = function(e, r) {
        t.props.onDayClick && t.props.onDayClick(e, r);
      }, t.handleDayMouseEnter = function(e) {
        t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
      }, t.handleWeekClick = function(e, r, o) {
        for (var s, i, l, c = new Date(e), u = 0; u < 7; u++) {
          var d = new Date(e);
          d.setDate(d.getDate() + u);
          var p = !t.isDisabled(d);
          if (p) {
            c = d;
            break;
          }
        }
        typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(c, r, o), t.props.showWeekPicker && t.handleDayClick(c, o), ((s = t.props.shouldCloseOnSelect) !== null && s !== void 0 ? s : a.defaultProps.shouldCloseOnSelect) && ((l = (i = t.props).setOpen) === null || l === void 0 || l.call(i, !1));
      }, t.formatWeekNumber = function(e) {
        return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : As(e);
      }, t.isWeekDisabled = function() {
        for (var e = t.startOfWeek(), r = ve(e, 6), o = new Date(e); o <= r; ) {
          if (!t.isDisabled(o))
            return !1;
          o = ve(o, 1);
        }
        return !0;
      }, t.renderDays = function() {
        var e = t.startOfWeek(), r = [], o = t.formatWeekNumber(e);
        if (t.props.showWeekNumber) {
          var s = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, e, o) : void 0;
          r.push(m.createElement(ai, F({ key: "W" }, a.defaultProps, t.props, { weekNumber: o, isWeekDisabled: t.isWeekDisabled(), date: e, onClick: s })));
        }
        return r.concat([0, 1, 2, 3, 4, 5, 6].map(function(i) {
          var l = ve(e, i);
          return m.createElement(ni, F({}, a.defaultProps, t.props, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: t.handleDayClick.bind(t, l), onMouseEnter: t.handleDayMouseEnter.bind(t, l) }));
        }));
      }, t.startOfWeek = function() {
        return Te(t.props.day, t.props.locale, t.props.calendarStartDay);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !L(t.startOfWeek(), t.props.selected) && L(t.startOfWeek(), t.props.preSelection);
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.render = function() {
      var t = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": L(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return m.createElement("div", { className: ee(t) }, this.renderDays());
    }, a;
  }(Z)
), Ge, si = 6, Ve = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, zt = (Ge = {}, Ge[Ve.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, Ge[Ve.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, Ge[Ve.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, Ge), vt = 1;
function Xr(n, a) {
  return n ? Ve.FOUR_COLUMNS : a ? Ve.TWO_COLUMNS : Ve.THREE_COLUMNS;
}
var ii = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.MONTH_REFS = me([], Array(12), !0).map(function() {
        return Oe();
      }), t.QUARTER_REFS = me([], Array(4), !0).map(function() {
        return Oe();
      }), t.isDisabled = function(e) {
        return ie(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function(e) {
        return yr(e, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.handleDayClick = function(e, r) {
        var o, s;
        (s = (o = t.props).onDayClick) === null || s === void 0 || s.call(o, e, r, t.props.orderInDisplay);
      }, t.handleDayMouseEnter = function(e) {
        var r, o;
        (o = (r = t.props).onDayMouseEnter) === null || o === void 0 || o.call(r, e);
      }, t.handleMouseLeave = function() {
        var e, r;
        (r = (e = t.props).onMouseLeave) === null || r === void 0 || r.call(e);
      }, t.isRangeStartMonth = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : re(ae(o, e), s);
      }, t.isRangeStartQuarter = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : It(Qe(o, e), s);
      }, t.isRangeEndMonth = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : re(ae(o, e), i);
      }, t.isRangeEndQuarter = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : It(Qe(o, e), i);
      }, t.isInSelectingRangeMonth = function(e) {
        var r, o = t.props, s = o.day, i = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, u = o.startDate, d = o.endDate, p = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return !(i || l || c) || !p ? !1 : i && d ? pt(p, d, e, s) : l && u || c && u && !d ? pt(u, p, e, s) : !1;
      }, t.isSelectingMonthRangeStart = function(e) {
        var r;
        if (!t.isInSelectingRangeMonth(e))
          return !1;
        var o = t.props, s = o.day, i = o.startDate, l = o.selectsStart, c = ae(s, e), u = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return l ? re(c, u) : re(c, i);
      }, t.isSelectingMonthRangeEnd = function(e) {
        var r;
        if (!t.isInSelectingRangeMonth(e))
          return !1;
        var o = t.props, s = o.day, i = o.endDate, l = o.selectsEnd, c = o.selectsRange, u = ae(s, e), d = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return l || c ? re(u, d) : re(u, i);
      }, t.isInSelectingRangeQuarter = function(e) {
        var r, o = t.props, s = o.day, i = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, u = o.startDate, d = o.endDate, p = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return !(i || l || c) || !p ? !1 : i && d ? mt(p, d, e, s) : l && u || c && u && !d ? mt(u, p, e, s) : !1;
      }, t.isWeekInMonth = function(e) {
        var r = t.props.day, o = ve(e, 6);
        return re(e, r) || re(o, r);
      }, t.isCurrentMonth = function(e, r) {
        return Y(e) === Y(Q()) && r === ne(Q());
      }, t.isCurrentQuarter = function(e, r) {
        return Y(e) === Y(Q()) && r === Fe(Q());
      }, t.isSelectedMonth = function(e, r, o) {
        return ne(o) === r && Y(e) === Y(o);
      }, t.isSelectMonthInList = function(e, r, o) {
        return o.some(function(s) {
          return t.isSelectedMonth(e, r, s);
        });
      }, t.isSelectedQuarter = function(e, r, o) {
        return Fe(e) === r && Y(e) === Y(o);
      }, t.renderWeeks = function() {
        for (var e = [], r = t.props.fixedHeight, o = 0, s = !1, i = Te(Ce(t.props.day), t.props.locale, t.props.calendarStartDay), l = function(h) {
          return t.props.showWeekPicker ? Te(h, t.props.locale, t.props.calendarStartDay) : t.props.preSelection;
        }, c = function(h) {
          return t.props.showWeekPicker ? Te(h, t.props.locale, t.props.calendarStartDay) : t.props.selected;
        }, u = t.props.selected ? c(t.props.selected) : void 0, d = t.props.preSelection ? l(t.props.preSelection) : void 0; e.push(m.createElement(oi, F({}, t.props, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, key: o, day: i, month: ne(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, selected: u, preSelection: d, showWeekNumber: t.props.showWeekNumbers }))), !s; ) {
          o++, i = Mt(i, 1);
          var p = r && o >= si, f = !r && !t.isWeekInMonth(i);
          if (p || f)
            if (t.props.peekNextMonth)
              s = !0;
            else
              break;
        }
        return e;
      }, t.onMonthClick = function(e, r) {
        var o = t.isMonthDisabledForLabelDate(r), s = o.isDisabled, i = o.labelDate;
        s || t.handleDayClick(Ce(i), e);
      }, t.onMonthMouseEnter = function(e) {
        var r = t.isMonthDisabledForLabelDate(e), o = r.isDisabled, s = r.labelDate;
        o || t.handleDayMouseEnter(Ce(s));
      }, t.handleMonthNavigation = function(e, r) {
        var o, s, i, l;
        (s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, r), (l = (i = t.MONTH_REFS[e]) === null || i === void 0 ? void 0 : i.current) === null || l === void 0 || l.focus();
      }, t.handleKeyboardNavigation = function(e, r, o) {
        var s, i = t.props, l = i.selected, c = i.preSelection, u = i.setPreSelection, d = i.minDate, p = i.maxDate, f = i.showFourColumnMonthYearPicker, h = i.showTwoColumnMonthYearPicker;
        if (c) {
          var g = Xr(f, h), v = t.getVerticalOffset(g), D = (s = zt[g]) === null || s === void 0 ? void 0 : s.grid, x = function(w, _, C) {
            var I, W, A = _, K = C;
            switch (w) {
              case y.ArrowRight:
                A = ye(_, vt), K = C === 11 ? 0 : C + vt;
                break;
              case y.ArrowLeft:
                A = Le(_, vt), K = C === 0 ? 11 : C - vt;
                break;
              case y.ArrowUp:
                A = Le(_, v), K = !((I = D == null ? void 0 : D[0]) === null || I === void 0) && I.includes(C) ? C + 12 - v : C - v;
                break;
              case y.ArrowDown:
                A = ye(_, v), K = !((W = D == null ? void 0 : D[D.length - 1]) === null || W === void 0) && W.includes(C) ? C - 12 + v : C + v;
                break;
            }
            return { newCalculatedDate: A, newCalculatedMonth: K };
          }, k = function(w, _, C) {
            for (var I = 40, W = w, A = !1, K = 0, V = x(W, _, C), B = V.newCalculatedDate, P = V.newCalculatedMonth; !A; ) {
              if (K >= I) {
                B = _, P = C;
                break;
              }
              if (d && B < d) {
                W = y.ArrowRight;
                var R = x(W, B, P);
                B = R.newCalculatedDate, P = R.newCalculatedMonth;
              }
              if (p && B > p) {
                W = y.ArrowLeft;
                var R = x(W, B, P);
                B = R.newCalculatedDate, P = R.newCalculatedMonth;
              }
              if (qs(B, t.props)) {
                var R = x(W, B, P);
                B = R.newCalculatedDate, P = R.newCalculatedMonth;
              } else
                A = !0;
              K++;
            }
            return { newCalculatedDate: B, newCalculatedMonth: P };
          };
          if (r === y.Enter) {
            t.isMonthDisabled(o) || (t.onMonthClick(e, o), u == null || u(l));
            return;
          }
          var E = k(r, c, o), S = E.newCalculatedDate, N = E.newCalculatedMonth;
          switch (r) {
            case y.ArrowRight:
            case y.ArrowLeft:
            case y.ArrowUp:
            case y.ArrowDown:
              t.handleMonthNavigation(N, S);
              break;
          }
        }
      }, t.getVerticalOffset = function(e) {
        var r, o;
        return (o = (r = zt[e]) === null || r === void 0 ? void 0 : r.verticalNavigationOffset) !== null && o !== void 0 ? o : 0;
      }, t.onMonthKeyDown = function(e, r) {
        var o = t.props, s = o.disabledKeyboardNavigation, i = o.handleOnMonthKeyDown, l = e.key;
        l !== y.Tab && e.preventDefault(), s || t.handleKeyboardNavigation(e, l, r), i && i(e);
      }, t.onQuarterClick = function(e, r) {
        var o = Qe(t.props.day, r);
        ft(o, t.props) || t.handleDayClick(Ir(o), e);
      }, t.onQuarterMouseEnter = function(e) {
        var r = Qe(t.props.day, e);
        ft(r, t.props) || t.handleDayMouseEnter(Ir(r));
      }, t.handleQuarterNavigation = function(e, r) {
        var o, s, i, l;
        t.isDisabled(r) || t.isExcluded(r) || ((s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, r), (l = (i = t.QUARTER_REFS[e - 1]) === null || i === void 0 ? void 0 : i.current) === null || l === void 0 || l.focus());
      }, t.onQuarterKeyDown = function(e, r) {
        var o, s, i = e.key;
        if (!t.props.disabledKeyboardNavigation)
          switch (i) {
            case y.Enter:
              t.onQuarterClick(e, r), (s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, t.props.selected);
              break;
            case y.ArrowRight:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(r === 4 ? 1 : r + 1, ur(t.props.preSelection, 1));
              break;
            case y.ArrowLeft:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(r === 1 ? 4 : r - 1, mn(t.props.preSelection));
              break;
          }
      }, t.isMonthDisabledForLabelDate = function(e) {
        var r, o = t.props, s = o.day, i = o.minDate, l = o.maxDate, c = o.excludeDates, u = o.includeDates, d = ae(s, e);
        return {
          isDisabled: (r = (i || l || c || u) && Tn(d, t.props)) !== null && r !== void 0 ? r : !1,
          labelDate: d
        };
      }, t.isMonthDisabled = function(e) {
        var r = t.isMonthDisabledForLabelDate(e).isDisabled;
        return r;
      }, t.getMonthClassNames = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate, l = r.preSelection, c = r.monthClassName, u = c ? c(ae(o, e)) : void 0, d = t.getSelection();
        return ee("react-datepicker__month-text", "react-datepicker__month-".concat(e), u, {
          "react-datepicker__month-text--disabled": t.isMonthDisabled(e),
          "react-datepicker__month-text--selected": d ? t.isSelectMonthInList(o, e, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && l && t.isSelectedMonth(o, e, l) && !t.isMonthDisabled(e),
          "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(e),
          "react-datepicker__month-text--in-range": s && i ? pt(s, i, e, o) : void 0,
          "react-datepicker__month-text--range-start": t.isRangeStartMonth(e),
          "react-datepicker__month-text--range-end": t.isRangeEndMonth(e),
          "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(e),
          "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(e),
          "react-datepicker__month-text--today": t.isCurrentMonth(o, e)
        });
      }, t.getTabIndex = function(e) {
        if (t.props.preSelection == null)
          return "-1";
        var r = ne(t.props.preSelection), o = t.isMonthDisabledForLabelDate(r).isDisabled, s = e === r && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return s;
      }, t.getQuarterTabIndex = function(e) {
        if (t.props.preSelection == null)
          return "-1";
        var r = Fe(t.props.preSelection), o = ft(t.props.day, t.props), s = e === r && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return s;
      }, t.getAriaLabel = function(e) {
        var r = t.props, o = r.chooseDayAriaLabelPrefix, s = o === void 0 ? "Choose" : o, i = r.disabledDayAriaLabelPrefix, l = i === void 0 ? "Not available" : i, c = r.day, u = r.locale, d = ae(c, e), p = t.isDisabled(d) || t.isExcluded(d) ? l : s;
        return "".concat(p, " ").concat(U(d, "MMMM yyyy", u));
      }, t.getQuarterClassNames = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate, l = r.selected, c = r.minDate, u = r.maxDate, d = r.excludeDates, p = r.includeDates, f = r.filterDate, h = r.preSelection, g = r.disabledKeyboardNavigation, v = (c || u || d || p || f) && ft(Qe(o, e), t.props);
        return ee("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
          "react-datepicker__quarter-text--disabled": v,
          "react-datepicker__quarter-text--selected": l ? t.isSelectedQuarter(o, e, l) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !g && h && t.isSelectedQuarter(o, e, h) && !v,
          "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(e),
          "react-datepicker__quarter-text--in-range": s && i ? mt(s, i, e, o) : void 0,
          "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(e),
          "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(e)
        });
      }, t.getMonthContent = function(e) {
        var r = t.props, o = r.showFullMonthYearPicker, s = r.renderMonthContent, i = r.locale, l = r.day, c = Pn(e, i), u = wr(e, i);
        return s ? s(e, c, u, l) : o ? u : c;
      }, t.getQuarterContent = function(e) {
        var r, o = t.props, s = o.renderQuarterContent, i = o.locale, l = Us(e, i);
        return (r = s == null ? void 0 : s(e, l)) !== null && r !== void 0 ? r : l;
      }, t.renderMonths = function() {
        var e, r = t.props, o = r.showTwoColumnMonthYearPicker, s = r.showFourColumnMonthYearPicker, i = r.day, l = r.selected, c = (e = zt[Xr(s, o)]) === null || e === void 0 ? void 0 : e.grid;
        return c == null ? void 0 : c.map(function(u, d) {
          return m.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, u.map(function(p, f) {
            return m.createElement("div", { ref: t.MONTH_REFS[p], key: f, onClick: function(h) {
              t.onMonthClick(h, p);
            }, onKeyDown: function(h) {
              Rn(h) && (h.preventDefault(), h.key = y.Enter), t.onMonthKeyDown(h, p);
            }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
              return t.onMonthMouseEnter(p);
            }, onPointerEnter: t.props.usePointerEvent ? function() {
              return t.onMonthMouseEnter(p);
            } : void 0, tabIndex: Number(t.getTabIndex(p)), className: t.getMonthClassNames(p), "aria-disabled": t.isMonthDisabled(p), role: "option", "aria-label": t.getAriaLabel(p), "aria-current": t.isCurrentMonth(i, p) ? "date" : void 0, "aria-selected": l ? t.isSelectedMonth(i, p, l) : void 0 }, t.getMonthContent(p));
          }));
        });
      }, t.renderQuarters = function() {
        var e = t.props, r = e.day, o = e.selected, s = [1, 2, 3, 4];
        return m.createElement("div", { className: "react-datepicker__quarter-wrapper" }, s.map(function(i, l) {
          return m.createElement("div", { key: l, ref: t.QUARTER_REFS[l], role: "option", onClick: function(c) {
            t.onQuarterClick(c, i);
          }, onKeyDown: function(c) {
            t.onQuarterKeyDown(c, i);
          }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onQuarterMouseEnter(i);
          }, onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onQuarterMouseEnter(i);
          } : void 0, className: t.getQuarterClassNames(i), "aria-selected": o ? t.isSelectedQuarter(r, i, o) : void 0, tabIndex: Number(t.getQuarterTabIndex(i)), "aria-current": t.isCurrentQuarter(r, i) ? "date" : void 0 }, t.getQuarterContent(i));
        }));
      }, t.getClassNames = function() {
        var e = t.props, r = e.selectingDate, o = e.selectsStart, s = e.selectsEnd, i = e.showMonthYearPicker, l = e.showQuarterYearPicker, c = e.showWeekPicker;
        return ee("react-datepicker__month", {
          "react-datepicker__month--selecting-range": r && (o || s)
        }, { "react-datepicker__monthPicker": i }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": c });
      }, t;
    }
    return a.prototype.getSelection = function() {
      var t = this.props, e = t.selected, r = t.selectedDates, o = t.selectsMultiple;
      if (o)
        return r;
      if (e)
        return [e];
    }, a.prototype.render = function() {
      var t = this.props, e = t.showMonthYearPicker, r = t.showQuarterYearPicker, o = t.day, s = t.ariaLabelPrefix, i = s === void 0 ? "Month " : s, l = i ? i.trim() + " " : "";
      return m.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(U(o, "MMMM, yyyy", this.props.locale)), role: "listbox" }, e ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
    }, a;
  }(Z)
), li = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.isSelectedMonth = function(e) {
        return t.props.month === e;
      }, t.renderOptions = function() {
        return t.props.monthNames.map(function(e, r) {
          return m.createElement(
            "div",
            { className: t.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: e, onClick: t.onChange.bind(t, r), "aria-selected": t.isSelectedMonth(r) ? "true" : void 0 },
            t.isSelectedMonth(r) ? m.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            e
          );
        });
      }, t.onChange = function(e) {
        return t.props.onChange(e);
      }, t.handleClickOutside = function() {
        return t.props.onCancel();
      }, t;
    }
    return a.prototype.render = function() {
      return m.createElement(Qt, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, a;
  }(Z)
), ci = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function(e) {
        return e.map(function(r, o) {
          return m.createElement("option", { key: r, value: o }, r);
        });
      }, t.renderSelectMode = function(e) {
        return m.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(r) {
          return t.onChange(parseInt(r.target.value));
        } }, t.renderSelectOptions(e));
      }, t.renderReadView = function(e, r) {
        return m.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown },
          m.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          m.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, r[t.props.month])
        );
      }, t.renderDropdown = function(e) {
        return m.createElement(li, F({ key: "dropdown" }, t.props, { monthNames: e, onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function(e) {
        var r = t.state.dropdownVisible, o = [t.renderReadView(!r, e)];
        return r && o.unshift(t.renderDropdown(e)), o;
      }, t.onChange = function(e) {
        t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return a.prototype.render = function() {
      var t = this, e = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
        return Pn(o, t.props.locale);
      } : function(o) {
        return wr(o, t.props.locale);
      }), r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode(e);
          break;
        case "select":
          r = this.renderSelectMode(e);
          break;
      }
      return m.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, r);
    }, a;
  }(Z)
);
function ui(n, a) {
  for (var t = [], e = Ce(n), r = Ce(a); !Ne(e, r); )
    t.push(Q(e)), e = ye(e, 1);
  return t;
}
var di = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.renderOptions = function() {
        return e.state.monthYearsList.map(function(r) {
          var o = nr(r), s = pe(e.props.date, r) && re(e.props.date, r);
          return m.createElement(
            "div",
            { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: e.onChange.bind(e, o), "aria-selected": s ? "true" : void 0 },
            s ? m.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            U(r, e.props.dateFormat, e.props.locale)
          );
        });
      }, e.onChange = function(r) {
        return e.props.onChange(r);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.state = {
        monthYearsList: ui(e.props.minDate, e.props.maxDate)
      }, e;
    }
    return a.prototype.render = function() {
      var t = ee({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return m.createElement(Qt, { className: t, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, a;
  }(Z)
), pi = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var e = Ce(t.props.minDate), r = Ce(t.props.maxDate), o = []; !Ne(e, r); ) {
          var s = nr(e);
          o.push(m.createElement("option", { key: s, value: s }, U(e, t.props.dateFormat, t.props.locale))), e = ye(e, 1);
        }
        return o;
      }, t.onSelectChange = function(e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function() {
        return m.createElement("select", { value: nr(Ce(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(e) {
        var r = U(t.props.date, t.props.dateFormat, t.props.locale);
        return m.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: t.toggleDropdown },
          m.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          m.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, r)
        );
      }, t.renderDropdown = function() {
        return m.createElement(di, F({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var e = t.state.dropdownVisible, r = [t.renderReadView(!e)];
        return e && r.unshift(t.renderDropdown()), r;
      }, t.onChange = function(e) {
        t.toggleDropdown();
        var r = Q(e);
        pe(t.props.date, r) && re(t.props.date, r) || t.props.onChange(r);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return a.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return m.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, a;
  }(Z)
), fi = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        height: null
      }, t.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var e, r, o;
          t.list && (t.list.scrollTop = (o = t.centerLi && a.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - ((r = (e = t.header) === null || e === void 0 ? void 0 : e.clientHeight) !== null && r !== void 0 ? r : 0) : t.list.clientHeight, t.centerLi)) !== null && o !== void 0 ? o : 0);
        });
      }, t.handleClick = function(e) {
        var r, o;
        (t.props.minTime || t.props.maxTime) && Wr(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Hr(e, t.props) || (o = (r = t.props).onChange) === null || o === void 0 || o.call(r, e);
      }, t.isSelectedTime = function(e) {
        return t.props.selected && ti(t.props.selected, e);
      }, t.isDisabledTime = function(e) {
        return (t.props.minTime || t.props.maxTime) && Wr(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Hr(e, t.props);
      }, t.liClasses = function(e) {
        var r, o = [
          "react-datepicker__time-list-item",
          t.props.timeClassName ? t.props.timeClassName(e) : void 0
        ];
        return t.isSelectedTime(e) && o.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(e) && o.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (ge(e) * 3600 + De(e) * 60 + Me(e)) % (((r = t.props.intervals) !== null && r !== void 0 ? r : a.defaultProps.intervals) * 60) !== 0 && o.push("react-datepicker__time-list-item--injected"), o.join(" ");
      }, t.handleOnKeyDown = function(e, r) {
        var o, s;
        e.key === y.Space && (e.preventDefault(), e.key = y.Enter), (e.key === y.ArrowUp || e.key === y.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === y.ArrowDown || e.key === y.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === y.Enter && t.handleClick(r), (s = (o = t.props).handleOnKeyDown) === null || s === void 0 || s.call(o, e);
      }, t.renderTimes = function() {
        for (var e, r = [], o = typeof t.props.format == "string" ? t.props.format : "p", s = (e = t.props.intervals) !== null && e !== void 0 ? e : a.defaultProps.intervals, i = t.props.selected || t.props.openToDate || Q(), l = bt(i), c = t.props.injectTimes && t.props.injectTimes.sort(function(v, D) {
          return v.getTime() - D.getTime();
        }), u = 60 * ei(i), d = u / s, p = 0; p < d; p++) {
          var f = tr(l, p * s);
          if (r.push(f), c) {
            var h = Js(l, f, p, s, c);
            r = r.concat(h);
          }
        }
        var g = r.reduce(function(v, D) {
          return D.getTime() <= i.getTime() ? D : v;
        }, r[0]);
        return r.map(function(v) {
          return m.createElement("li", { key: v.valueOf(), onClick: t.handleClick.bind(t, v), className: t.liClasses(v), ref: function(D) {
            v === g && (t.centerLi = D);
          }, onKeyDown: function(D) {
            t.handleOnKeyDown(D, v);
          }, tabIndex: v === g ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(v) ? "true" : void 0, "aria-disabled": t.isDisabledTime(v) ? "true" : void 0 }, U(v, o, t.props.locale));
        });
      }, t.renderTimeCaption = function() {
        return t.props.showTimeCaption === !1 ? m.createElement(m.Fragment, null) : m.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(t.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(e) {
            t.header = e;
          } },
          m.createElement("div", { className: "react-datepicker-time__header" }, t.props.timeCaption)
        );
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, a.prototype.render = function() {
      var t = this, e, r = this.state.height;
      return m.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((e = this.props.todayButton) !== null && e !== void 0 ? e : a.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        m.createElement(
          "div",
          { className: "react-datepicker__time" },
          m.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            m.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
              t.list = o;
            }, style: r ? { height: r } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, a.calcCenterPosition = function(t, e) {
      return e.offsetTop - (t / 2 - e.clientHeight / 2);
    }, a;
  }(Z)
), Gr = 3, hi = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.YEAR_REFS = me([], Array(e.props.yearItemNumber), !0).map(function() {
        return Oe();
      }), e.isDisabled = function(r) {
        return ie(r, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function(r) {
        return yr(r, {
          excludeDates: e.props.excludeDates
        });
      }, e.selectingDate = function() {
        var r;
        return (r = e.props.selectingDate) !== null && r !== void 0 ? r : e.props.preSelection;
      }, e.updateFocusOnPaginate = function(r) {
        var o = function() {
          var s, i;
          (i = (s = e.YEAR_REFS[r]) === null || s === void 0 ? void 0 : s.current) === null || i === void 0 || i.focus();
        };
        window.requestAnimationFrame(o);
      }, e.handleYearClick = function(r, o) {
        e.props.onDayClick && e.props.onDayClick(r, o);
      }, e.handleYearNavigation = function(r, o) {
        var s, i, l, c, u = e.props, d = u.date, p = u.yearItemNumber;
        if (!(d === void 0 || p === void 0)) {
          var f = Ee(d, p).startPeriod;
          e.isDisabled(o) || e.isExcluded(o) || ((i = (s = e.props).setPreSelection) === null || i === void 0 || i.call(s, o), r - f < 0 ? e.updateFocusOnPaginate(p - (f - r)) : r - f >= p ? e.updateFocusOnPaginate(Math.abs(p - (r - f))) : (c = (l = e.YEAR_REFS[r - f]) === null || l === void 0 ? void 0 : l.current) === null || c === void 0 || c.focus());
        }
      }, e.isSameDay = function(r, o) {
        return L(r, o);
      }, e.isCurrentYear = function(r) {
        return r === Y(Q());
      }, e.isRangeStart = function(r) {
        return e.props.startDate && e.props.endDate && pe(de(Q(), r), e.props.startDate);
      }, e.isRangeEnd = function(r) {
        return e.props.startDate && e.props.endDate && pe(de(Q(), r), e.props.endDate);
      }, e.isInRange = function(r) {
        return ht(r, e.props.startDate, e.props.endDate);
      }, e.isInSelectingRange = function(r) {
        var o = e.props, s = o.selectsStart, i = o.selectsEnd, l = o.selectsRange, c = o.startDate, u = o.endDate;
        return !(s || i || l) || !e.selectingDate() ? !1 : s && u ? ht(r, e.selectingDate(), u) : i && c || l && c && !u ? ht(r, c, e.selectingDate()) : !1;
      }, e.isSelectingRangeStart = function(r) {
        var o;
        if (!e.isInSelectingRange(r))
          return !1;
        var s = e.props, i = s.startDate, l = s.selectsStart, c = de(Q(), r);
        return l ? pe(c, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : pe(c, i ?? null);
      }, e.isSelectingRangeEnd = function(r) {
        var o;
        if (!e.isInSelectingRange(r))
          return !1;
        var s = e.props, i = s.endDate, l = s.selectsEnd, c = s.selectsRange, u = de(Q(), r);
        return l || c ? pe(u, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : pe(u, i ?? null);
      }, e.isKeyboardSelected = function(r) {
        if (!(e.props.date === void 0 || e.props.selected == null || e.props.preSelection == null)) {
          var o = e.props, s = o.minDate, i = o.maxDate, l = o.excludeDates, c = o.includeDates, u = o.filterDate, d = Ze(de(e.props.date, r)), p = (s || i || l || c || u) && _t(r, e.props);
          return !e.props.disabledKeyboardNavigation && !e.props.inline && !L(d, Ze(e.props.selected)) && L(d, Ze(e.props.preSelection)) && !p;
        }
      }, e.onYearClick = function(r, o) {
        var s = e.props.date;
        s !== void 0 && e.handleYearClick(Ze(de(s, o)), r);
      }, e.onYearKeyDown = function(r, o) {
        var s, i, l = r.key, c = e.props, u = c.date, d = c.yearItemNumber, p = c.handleOnKeyDown;
        if (l !== y.Tab && r.preventDefault(), !e.props.disabledKeyboardNavigation)
          switch (l) {
            case y.Enter:
              if (e.props.selected == null)
                break;
              e.onYearClick(r, o), (i = (s = e.props).setPreSelection) === null || i === void 0 || i.call(s, e.props.selected);
              break;
            case y.ArrowRight:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(o + 1, xe(e.props.preSelection, 1));
              break;
            case y.ArrowLeft:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(o - 1, Ue(e.props.preSelection, 1));
              break;
            case y.ArrowUp: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var f = Ee(u, d).startPeriod, h = Gr, g = o - h;
              if (g < f) {
                var v = d % h;
                o >= f && o < f + v ? h = v : h += v, g = o - h;
              }
              e.handleYearNavigation(g, Ue(e.props.preSelection, h));
              break;
            }
            case y.ArrowDown: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var D = Ee(u, d).endPeriod, h = Gr, g = o + h;
              if (g > D) {
                var v = d % h;
                o <= D && o > D - v ? h = v : h += v, g = o + h;
              }
              e.handleYearNavigation(g, xe(e.props.preSelection, h));
              break;
            }
          }
        p && p(r);
      }, e.getYearClassNames = function(r) {
        var o = e.props, s = o.date, i = o.minDate, l = o.maxDate, c = o.selected, u = o.excludeDates, d = o.includeDates, p = o.filterDate, f = o.yearClassName;
        return ee("react-datepicker__year-text", "react-datepicker__year-".concat(r), s ? f == null ? void 0 : f(de(s, r)) : void 0, {
          "react-datepicker__year-text--selected": c ? r === Y(c) : void 0,
          "react-datepicker__year-text--disabled": (i || l || u || d || p) && _t(r, e.props),
          "react-datepicker__year-text--keyboard-selected": e.isKeyboardSelected(r),
          "react-datepicker__year-text--range-start": e.isRangeStart(r),
          "react-datepicker__year-text--range-end": e.isRangeEnd(r),
          "react-datepicker__year-text--in-range": e.isInRange(r),
          "react-datepicker__year-text--in-selecting-range": e.isInSelectingRange(r),
          "react-datepicker__year-text--selecting-range-start": e.isSelectingRangeStart(r),
          "react-datepicker__year-text--selecting-range-end": e.isSelectingRangeEnd(r),
          "react-datepicker__year-text--today": e.isCurrentYear(r)
        });
      }, e.getYearTabIndex = function(r) {
        if (e.props.disabledKeyboardNavigation || e.props.preSelection == null)
          return "-1";
        var o = Y(e.props.preSelection), s = _t(r, e.props);
        return r === o && !s ? "0" : "-1";
      }, e.getYearContent = function(r) {
        return e.props.renderYearContent ? e.props.renderYearContent(r) : r;
      }, e;
    }
    return a.prototype.render = function() {
      var t = this, e = [], r = this.props, o = r.date, s = r.yearItemNumber, i = r.onYearMouseEnter, l = r.onYearMouseLeave;
      if (o === void 0)
        return null;
      for (var c = Ee(o, s), u = c.startPeriod, d = c.endPeriod, p = function(g) {
        e.push(m.createElement("div", { ref: f.YEAR_REFS[g - u], onClick: function(v) {
          t.onYearClick(v, g);
        }, onKeyDown: function(v) {
          Rn(v) && (v.preventDefault(), v.key = y.Enter), t.onYearKeyDown(v, g);
        }, tabIndex: Number(f.getYearTabIndex(g)), className: f.getYearClassNames(g), onMouseEnter: f.props.usePointerEvent ? void 0 : function(v) {
          return i(v, g);
        }, onPointerEnter: f.props.usePointerEvent ? function(v) {
          return i(v, g);
        } : void 0, onMouseLeave: f.props.usePointerEvent ? void 0 : function(v) {
          return l(v, g);
        }, onPointerLeave: f.props.usePointerEvent ? function(v) {
          return l(v, g);
        } : void 0, key: g, "aria-current": f.isCurrentYear(g) ? "date" : void 0 }, f.getYearContent(g)));
      }, f = this, h = u; h <= d; h++)
        p(h);
      return m.createElement(
        "div",
        { className: "react-datepicker__year" },
        m.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, e)
      );
    }, a;
  }(Z)
);
function mi(n, a, t, e) {
  for (var r = [], o = 0; o < 2 * a + 1; o++) {
    var s = n + a - o, i = !0;
    t && (i = Y(t) <= s), e && i && (i = Y(e) >= s), i && r.push(s);
  }
  return r;
}
var vi = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      e.renderOptions = function() {
        var i = e.props.year, l = e.state.yearsList.map(function(d) {
          return m.createElement(
            "div",
            { className: i === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: e.onChange.bind(e, d), "aria-selected": i === d ? "true" : void 0 },
            i === d ? m.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), c = e.props.minDate ? Y(e.props.minDate) : null, u = e.props.maxDate ? Y(e.props.maxDate) : null;
        return (!u || !e.state.yearsList.find(function(d) {
          return d === u;
        })) && l.unshift(m.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: e.incrementYears },
          m.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!c || !e.state.yearsList.find(function(d) {
          return d === c;
        })) && l.push(m.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: e.decrementYears },
          m.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, e.onChange = function(i) {
        e.props.onChange(i);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.shiftYears = function(i) {
        var l = e.state.yearsList.map(function(c) {
          return c + i;
        });
        e.setState({
          yearsList: l
        });
      }, e.incrementYears = function() {
        return e.shiftYears(1);
      }, e.decrementYears = function() {
        return e.shiftYears(-1);
      };
      var r = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = r || (o ? 10 : 5);
      return e.state = {
        yearsList: mi(e.props.year, s, e.props.minDate, e.props.maxDate)
      }, e.dropdownRef = Oe(), e;
    }
    return a.prototype.componentDidMount = function() {
      var t = this.dropdownRef.current;
      if (t) {
        var e = t.children ? Array.from(t.children) : null, r = e ? e.find(function(o) {
          return o.ariaSelected;
        }) : null;
        t.scrollTop = r && r instanceof HTMLElement ? r.offsetTop + (r.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
      }
    }, a.prototype.render = function() {
      var t = ee({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return m.createElement(Qt, { className: t, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, a;
  }(Z)
), gi = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var e = t.props.minDate ? Y(t.props.minDate) : 1900, r = t.props.maxDate ? Y(t.props.maxDate) : 2100, o = [], s = e; s <= r; s++)
          o.push(m.createElement("option", { key: s, value: s }, s));
        return o;
      }, t.onSelectChange = function(e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function() {
        return m.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(e) {
        return m.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(r) {
            return t.toggleDropdown(r);
          } },
          m.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          m.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year)
        );
      }, t.renderDropdown = function() {
        return m.createElement(vi, F({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var e = t.state.dropdownVisible, r = [t.renderReadView(!e)];
        return e && r.unshift(t.renderDropdown()), r;
      }, t.onChange = function(e) {
        t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
      }, t.toggleDropdown = function(e) {
        t.setState({
          dropdownVisible: !t.state.dropdownVisible
        }, function() {
          t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
        });
      }, t.handleYearChange = function(e, r) {
        var o;
        (o = t.onSelect) === null || o === void 0 || o.call(t, e, r), t.setOpen();
      }, t.onSelect = function(e, r) {
        var o, s;
        (s = (o = t.props).onSelect) === null || s === void 0 || s.call(o, e, r);
      }, t.setOpen = function() {
        var e, r;
        (r = (e = t.props).setOpen) === null || r === void 0 || r.call(e, !0);
      }, t;
    }
    return a.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return m.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, a;
  }(Z)
), Di = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], wi = function(n) {
  var a = (n.className || "").split(/\s+/);
  return Di.some(function(t) {
    return a.indexOf(t) >= 0;
  });
}, yi = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.monthContainer = void 0, e.handleClickOutside = function(r) {
        e.props.onClickOutside(r);
      }, e.setClickOutsideRef = function() {
        return e.containerRef.current;
      }, e.handleDropdownFocus = function(r) {
        var o, s;
        wi(r.target) && ((s = (o = e.props).onDropdownFocus) === null || s === void 0 || s.call(o, r));
      }, e.getDateInView = function() {
        var r = e.props, o = r.preSelection, s = r.selected, i = r.openToDate, l = On(e.props), c = Nn(e.props), u = Q(), d = i || s || o;
        return d || (l && We(u, l) ? l : c && Ne(u, c) ? c : u);
      }, e.increaseMonth = function() {
        e.setState(function(r) {
          var o = r.date;
          return {
            date: ye(o, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.decreaseMonth = function() {
        e.setState(function(r) {
          var o = r.date;
          return {
            date: Le(o, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.handleDayClick = function(r, o, s) {
        e.props.onSelect(r, o, s), e.props.setPreSelection && e.props.setPreSelection(r);
      }, e.handleDayMouseEnter = function(r) {
        e.setState({ selectingDate: r }), e.props.onDayMouseEnter && e.props.onDayMouseEnter(r);
      }, e.handleMonthMouseLeave = function() {
        e.setState({ selectingDate: void 0 }), e.props.onMonthMouseLeave && e.props.onMonthMouseLeave();
      }, e.handleYearMouseEnter = function(r, o) {
        e.setState({ selectingDate: de(Q(), o) }), e.props.onYearMouseEnter && e.props.onYearMouseEnter(r, o);
      }, e.handleYearMouseLeave = function(r, o) {
        e.props.onYearMouseLeave && e.props.onYearMouseLeave(r, o);
      }, e.handleYearChange = function(r) {
        var o, s, i, l;
        (s = (o = e.props).onYearChange) === null || s === void 0 || s.call(o, r), e.setState({ isRenderAriaLiveMessage: !0 }), e.props.adjustDateOnChange && (e.props.onSelect(r), (l = (i = e.props).setOpen) === null || l === void 0 || l.call(i, !0)), e.props.setPreSelection && e.props.setPreSelection(r);
      }, e.getEnabledPreSelectionDateForMonth = function(r) {
        if (!ie(r, e.props))
          return r;
        for (var o = Ce(r), s = Bs(r), i = ra(s, o), l = null, c = 0; c <= i; c++) {
          var u = ve(o, c);
          if (!ie(u, e.props)) {
            l = u;
            break;
          }
        }
        return l;
      }, e.handleMonthChange = function(r) {
        var o, s, i, l = (o = e.getEnabledPreSelectionDateForMonth(r)) !== null && o !== void 0 ? o : r;
        e.handleCustomMonthChange(l), e.props.adjustDateOnChange && (e.props.onSelect(l), (i = (s = e.props).setOpen) === null || i === void 0 || i.call(s, !0)), e.props.setPreSelection && e.props.setPreSelection(l);
      }, e.handleCustomMonthChange = function(r) {
        var o, s;
        (s = (o = e.props).onMonthChange) === null || s === void 0 || s.call(o, r), e.setState({ isRenderAriaLiveMessage: !0 });
      }, e.handleMonthYearChange = function(r) {
        e.handleYearChange(r), e.handleMonthChange(r);
      }, e.changeYear = function(r) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: de(s, Number(r))
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.changeMonth = function(r) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: ae(s, Number(r))
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.changeMonthYear = function(r) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: de(ae(s, ne(r)), Y(r))
          };
        }, function() {
          return e.handleMonthYearChange(e.state.date);
        });
      }, e.header = function(r) {
        r === void 0 && (r = e.state.date);
        var o = Te(r, e.props.locale, e.props.calendarStartDay), s = [];
        return e.props.showWeekNumbers && s.push(m.createElement("div", { key: "W", className: "react-datepicker__day-name" }, e.props.weekLabel || "#")), s.concat([0, 1, 2, 3, 4, 5, 6].map(function(i) {
          var l = ve(o, i), c = e.formatWeekday(l, e.props.locale), u = e.props.weekDayClassName ? e.props.weekDayClassName(l) : void 0;
          return m.createElement("div", { key: i, "aria-label": U(l, "EEEE", e.props.locale), className: ee("react-datepicker__day-name", u) }, c);
        }));
      }, e.formatWeekday = function(r, o) {
        return e.props.formatWeekDay ? Qs(r, e.props.formatWeekDay, o) : e.props.useWeekdaysShort ? Vs(r, o) : Ks(r, o);
      }, e.decreaseYear = function() {
        e.setState(function(r) {
          var o, s = r.date;
          return {
            date: Ue(s, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : a.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.clearSelectingDate = function() {
        e.setState({ selectingDate: void 0 });
      }, e.renderPreviousButton = function() {
        var r, o, s;
        if (!e.props.renderCustomHeader) {
          var i = (r = e.props.monthsShown) !== null && r !== void 0 ? r : a.defaultProps.monthsShown, l = e.props.showPreviousMonths ? i - 1 : 0, c = (o = e.props.monthSelectedIn) !== null && o !== void 0 ? o : l, u = Le(e.state.date, c), d;
          switch (!0) {
            case e.props.showMonthYearPicker:
              d = Kr(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              d = zs(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              d = $s(e.state.date, e.props);
              break;
            default:
              d = Br(u, e.props);
              break;
          }
          if (!(!((s = e.props.forceShowMonthNavigation) !== null && s !== void 0 ? s : a.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && d || e.props.showTimeSelectOnly)) {
            var p = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], f = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], h = e.decreaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (h = e.decreaseYear), d && e.props.showDisabledMonthNavigation && (f.push("react-datepicker__navigation--previous--disabled"), h = void 0);
            var g = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, v = e.props, D = v.previousMonthButtonLabel, x = D === void 0 ? a.defaultProps.previousMonthButtonLabel : D, k = v.previousYearButtonLabel, E = k === void 0 ? a.defaultProps.previousYearButtonLabel : k, S = e.props, N = S.previousMonthAriaLabel, w = N === void 0 ? typeof x == "string" ? x : "Previous Month" : N, _ = S.previousYearAriaLabel, C = _ === void 0 ? typeof E == "string" ? E : "Previous Year" : _;
            return m.createElement(
              "button",
              { type: "button", className: f.join(" "), onClick: h, onKeyDown: e.props.handleOnKeyDown, "aria-label": g ? C : w },
              m.createElement("span", { className: p.join(" ") }, g ? E : x)
            );
          }
        }
      }, e.increaseYear = function() {
        e.setState(function(r) {
          var o, s = r.date;
          return {
            date: xe(s, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : a.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.renderNextButton = function() {
        var r;
        if (!e.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case e.props.showMonthYearPicker:
              o = Vr(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              o = Xs(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              o = js(e.state.date, e.props);
              break;
            default:
              o = Qr(e.state.date, e.props);
              break;
          }
          if (!(!((r = e.props.forceShowMonthNavigation) !== null && r !== void 0 ? r : a.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && o || e.props.showTimeSelectOnly)) {
            var s = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], i = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            e.props.showTimeSelect && s.push("react-datepicker__navigation--next--with-time"), e.props.todayButton && s.push("react-datepicker__navigation--next--with-today-button");
            var l = e.increaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (l = e.increaseYear), o && e.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var c = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, d = u.nextMonthButtonLabel, p = d === void 0 ? a.defaultProps.nextMonthButtonLabel : d, f = u.nextYearButtonLabel, h = f === void 0 ? a.defaultProps.nextYearButtonLabel : f, g = e.props, v = g.nextMonthAriaLabel, D = v === void 0 ? typeof p == "string" ? p : "Next Month" : v, x = g.nextYearAriaLabel, k = x === void 0 ? typeof h == "string" ? h : "Next Year" : x;
            return m.createElement(
              "button",
              { type: "button", className: s.join(" "), onClick: l, onKeyDown: e.props.handleOnKeyDown, "aria-label": c ? k : D },
              m.createElement("span", { className: i.join(" ") }, c ? h : p)
            );
          }
        }
      }, e.renderCurrentMonth = function(r) {
        r === void 0 && (r = e.state.date);
        var o = ["react-datepicker__current-month"];
        return e.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), e.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), e.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), m.createElement("h2", { className: o.join(" ") }, U(r, e.props.dateFormat, e.props.locale));
      }, e.renderYearDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showYearDropdown || r))
          return m.createElement(gi, F({}, a.defaultProps, e.props, { date: e.state.date, onChange: e.changeYear, year: Y(e.state.date) }));
      }, e.renderMonthDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showMonthDropdown || r))
          return m.createElement(ci, F({}, a.defaultProps, e.props, { month: ne(e.state.date), onChange: e.changeMonth }));
      }, e.renderMonthYearDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showMonthYearDropdown || r))
          return m.createElement(pi, F({}, a.defaultProps, e.props, { date: e.state.date, onChange: e.changeMonthYear }));
      }, e.handleTodayButtonClick = function(r) {
        e.props.onSelect(Lr(), r), e.props.setPreSelection && e.props.setPreSelection(Lr());
      }, e.renderTodayButton = function() {
        if (!(!e.props.todayButton || e.props.showTimeSelectOnly))
          return m.createElement("div", { className: "react-datepicker__today-button", onClick: e.handleTodayButtonClick }, e.props.todayButton);
      }, e.renderDefaultHeader = function(r) {
        var o = r.monthDate, s = r.i;
        return m.createElement(
          "div",
          { className: "react-datepicker__header ".concat(e.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          e.renderCurrentMonth(o),
          m.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(e.props.dropdownMode), onFocus: e.handleDropdownFocus },
            e.renderMonthDropdown(s !== 0),
            e.renderMonthYearDropdown(s !== 0),
            e.renderYearDropdown(s !== 0)
          ),
          m.createElement("div", { className: "react-datepicker__day-names" }, e.header(o))
        );
      }, e.renderCustomHeader = function(r) {
        var o, s, i = r.monthDate, l = r.i;
        if (e.props.showTimeSelect && !e.state.monthContainer || e.props.showTimeSelectOnly)
          return null;
        var c = Br(e.state.date, e.props), u = Qr(e.state.date, e.props), d = Kr(e.state.date, e.props), p = Vr(e.state.date, e.props), f = !e.props.showMonthYearPicker && !e.props.showQuarterYearPicker && !e.props.showYearPicker;
        return m.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: e.props.onDropdownFocus },
          (s = (o = e.props).renderCustomHeader) === null || s === void 0 ? void 0 : s.call(o, F(F({}, e.state), { customHeaderCount: l, monthDate: i, changeMonth: e.changeMonth, changeYear: e.changeYear, decreaseMonth: e.decreaseMonth, increaseMonth: e.increaseMonth, decreaseYear: e.decreaseYear, increaseYear: e.increaseYear, prevMonthButtonDisabled: c, nextMonthButtonDisabled: u, prevYearButtonDisabled: d, nextYearButtonDisabled: p })),
          f && m.createElement("div", { className: "react-datepicker__day-names" }, e.header(i))
        );
      }, e.renderYearHeader = function(r) {
        var o = r.monthDate, s = e.props, i = s.showYearPicker, l = s.yearItemNumber, c = l === void 0 ? a.defaultProps.yearItemNumber : l, u = Ee(o, c), d = u.startPeriod, p = u.endPeriod;
        return m.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, i ? "".concat(d, " - ").concat(p) : Y(o));
      }, e.renderHeader = function(r) {
        var o = r.monthDate, s = r.i, i = s === void 0 ? 0 : s, l = { monthDate: o, i };
        switch (!0) {
          case e.props.renderCustomHeader !== void 0:
            return e.renderCustomHeader(l);
          case (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker):
            return e.renderYearHeader(l);
          default:
            return e.renderDefaultHeader(l);
        }
      }, e.renderMonths = function() {
        var r, o;
        if (!(e.props.showTimeSelectOnly || e.props.showYearPicker)) {
          for (var s = [], i = (r = e.props.monthsShown) !== null && r !== void 0 ? r : a.defaultProps.monthsShown, l = e.props.showPreviousMonths ? i - 1 : 0, c = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? xe(e.state.date, l) : Le(e.state.date, l), u = (o = e.props.monthSelectedIn) !== null && o !== void 0 ? o : l, d = 0; d < i; ++d) {
            var p = d - u + l, f = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? xe(c, p) : ye(c, p), h = "month-".concat(d), g = d < i - 1, v = d > 0;
            s.push(m.createElement(
              "div",
              { key: h, ref: function(D) {
                e.monthContainer = D ?? void 0;
              }, className: "react-datepicker__month-container" },
              e.renderHeader({ monthDate: f, i: d }),
              m.createElement(ii, F({}, a.defaultProps, e.props, { ariaLabelPrefix: e.props.monthAriaLabelPrefix, day: f, onDayClick: e.handleDayClick, handleOnKeyDown: e.props.handleOnDayKeyDown, handleOnMonthKeyDown: e.props.handleOnKeyDown, onDayMouseEnter: e.handleDayMouseEnter, onMouseLeave: e.handleMonthMouseLeave, orderInDisplay: d, selectingDate: e.state.selectingDate, monthShowsDuplicateDaysEnd: g, monthShowsDuplicateDaysStart: v }))
            ));
          }
          return s;
        }
      }, e.renderYears = function() {
        if (!e.props.showTimeSelectOnly && e.props.showYearPicker)
          return m.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            e.renderHeader({ monthDate: e.state.date }),
            m.createElement(hi, F({}, a.defaultProps, e.props, { selectingDate: e.state.selectingDate, date: e.state.date, onDayClick: e.handleDayClick, clearSelectingDate: e.clearSelectingDate, onYearMouseEnter: e.handleYearMouseEnter, onYearMouseLeave: e.handleYearMouseLeave }))
          );
      }, e.renderTimeSection = function() {
        if (e.props.showTimeSelect && (e.state.monthContainer || e.props.showTimeSelectOnly))
          return m.createElement(fi, F({}, a.defaultProps, e.props, { onChange: e.props.onTimeChange, format: e.props.timeFormat, intervals: e.props.timeIntervals, monthRef: e.state.monthContainer }));
      }, e.renderInputTimeSection = function() {
        var r = e.props.selected ? new Date(e.props.selected) : void 0, o = r && ke(r) && !!e.props.selected, s = o ? "".concat(qr(r.getHours()), ":").concat(qr(r.getMinutes())) : "";
        if (e.props.showTimeInput)
          return m.createElement(ri, F({}, a.defaultProps, e.props, { date: r, timeString: s, onChange: e.props.onTimeChange }));
      }, e.renderAriaLiveRegion = function() {
        var r, o = Ee(e.state.date, (r = e.props.yearItemNumber) !== null && r !== void 0 ? r : a.defaultProps.yearItemNumber), s = o.startPeriod, i = o.endPeriod, l;
        return e.props.showYearPicker ? l = "".concat(s, " - ").concat(i) : e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? l = Y(e.state.date) : l = "".concat(wr(ne(e.state.date), e.props.locale), " ").concat(Y(e.state.date)), m.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, e.state.isRenderAriaLiveMessage && l);
      }, e.renderChildren = function() {
        if (e.props.children)
          return m.createElement("div", { className: "react-datepicker__children-container" }, e.props.children);
      }, e.containerRef = Oe(), e.state = {
        date: e.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, e;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: lt
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      var t = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        t.setState({ monthContainer: t.monthContainer });
      }());
    }, a.prototype.componentDidUpdate = function(t) {
      var e = this;
      if (this.props.preSelection && (!L(this.props.preSelection, t.preSelection) || this.props.monthSelectedIn !== t.monthSelectedIn)) {
        var r = !re(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return r && e.handleCustomMonthChange(e.state.date);
        });
      } else this.props.openToDate && !L(this.props.openToDate, t.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, a.prototype.render = function() {
      var t = this.props.container || Rs;
      return m.createElement(
        Qt,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, containerRef: this.containerRef, ignoreClass: this.props.outsideClickIgnoreClass },
        m.createElement(
          t,
          { className: ee("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, a;
  }(Z)
), bi = function(n) {
  var a = n.icon, t = n.className, e = t === void 0 ? "" : t, r = n.onClick, o = "react-datepicker__calendar-icon";
  return typeof a == "string" ? m.createElement("i", { className: "".concat(o, " ").concat(a, " ").concat(e), "aria-hidden": "true", onClick: r }) : m.isValidElement(a) ? m.cloneElement(a, {
    className: "".concat(a.props.className || "", " ").concat(o, " ").concat(e),
    onClick: function(s) {
      typeof a.props.onClick == "function" && a.props.onClick(s), typeof r == "function" && r(s);
    }
  }) : m.createElement(
    "svg",
    { className: "".concat(o, " ").concat(e), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: r },
    m.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, Yn = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.portalRoot = null, e.el = document.createElement("div"), e;
    }
    return a.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, a.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, a.prototype.render = function() {
      return Gn.createPortal(this.props.children, this.el);
    }, a;
  }(Z)
), _i = "[tabindex], a, button, input, select, textarea", ki = function(n) {
  return (n instanceof HTMLAnchorElement || !n.disabled) && n.tabIndex !== -1;
}, In = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.getTabChildren = function() {
        var r;
        return Array.prototype.slice.call((r = e.tabLoopRef.current) === null || r === void 0 ? void 0 : r.querySelectorAll(_i), 1, -1).filter(ki);
      }, e.handleFocusStart = function() {
        var r = e.getTabChildren();
        r && r.length > 1 && r[r.length - 1].focus();
      }, e.handleFocusEnd = function() {
        var r = e.getTabChildren();
        r && r.length > 1 && r[0].focus();
      }, e.tabLoopRef = Oe(), e;
    }
    return a.prototype.render = function() {
      var t;
      return ((t = this.props.enableTabLoop) !== null && t !== void 0 ? t : a.defaultProps.enableTabLoop) ? m.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        m.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        m.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, a.defaultProps = {
      enableTabLoop: !0
    }, a;
  }(Z)
);
function xi(n) {
  var a = function(t) {
    var e, r = typeof t.hidePopper == "boolean" ? t.hidePopper : !0, o = kt(null), s = Ns(F({ open: !r, whileElementsMounted: ls, placement: t.popperPlacement, middleware: me([
      gs({ padding: 15 }),
      vs(10),
      Ds({ element: o })
    ], (e = t.popperModifiers) !== null && e !== void 0 ? e : [], !0) }, t.popperProps)), i = F(F({}, t), { hidePopper: r, popperProps: F(F({}, s), { arrowRef: o }) });
    return m.createElement(n, F({}, i));
  };
  return a;
}
var Mi = (
  /** @class */
  function(n) {
    J(a, n);
    function a() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.render = function() {
      var t = this.props, e = t.className, r = t.wrapperClassName, o = t.hidePopper, s = o === void 0 ? a.defaultProps.hidePopper : o, i = t.popperComponent, l = t.targetComponent, c = t.enableTabLoop, u = t.popperOnKeyDown, d = t.portalId, p = t.portalHost, f = t.popperProps, h = t.showArrow, g = void 0;
      if (!s) {
        var v = ee("react-datepicker-popper", e);
        g = m.createElement(
          In,
          { enableTabLoop: c },
          m.createElement(
            "div",
            { ref: f.refs.setFloating, style: f.floatingStyles, className: v, "data-placement": f.placement, onKeyDown: u },
            i,
            h && m.createElement(Ms, { ref: f.arrowRef, context: f.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (g = Wn(this.props.popperContainer, {}, g)), d && !s && (g = m.createElement(Yn, { portalId: d, portalHost: p }, g));
      var D = ee("react-datepicker-wrapper", r);
      return m.createElement(
        m.Fragment,
        null,
        m.createElement("div", { ref: f.refs.setReference, className: D }, l),
        g
      );
    }, a;
  }(Z)
), Ci = xi(Mi), Zr = "react-datepicker-ignore-onclickoutside";
function Si(n, a) {
  return n && a ? ne(n) !== ne(a) || Y(n) !== Y(a) : n !== a;
}
var Xt = "Date input not valid.", Ei = (
  /** @class */
  function(n) {
    J(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.calendar = null, e.input = null, e.getPreSelection = function() {
        return e.props.openToDate ? e.props.openToDate : e.props.selectsEnd && e.props.startDate ? e.props.startDate : e.props.selectsStart && e.props.endDate ? e.props.endDate : Q();
      }, e.modifyHolidays = function() {
        var r;
        return (r = e.props.holidays) === null || r === void 0 ? void 0 : r.reduce(function(o, s) {
          var i = new Date(s.date);
          return ke(i) ? me(me([], o, !0), [F(F({}, s), { date: i })], !1) : o;
        }, []);
      }, e.calcInitialState = function() {
        var r, o = e.getPreSelection(), s = On(e.props), i = Nn(e.props), l = s && We(o, bt(s)) ? s : i && Ne(o, Fr(i)) ? i : o;
        return {
          open: e.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (r = e.props.selectsRange ? e.props.startDate : e.props.selected) !== null && r !== void 0 ? r : l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: Ur(e.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, e.resetHiddenStatus = function() {
        e.setState(F(F({}, e.state), { wasHidden: !1 }));
      }, e.setHiddenStatus = function() {
        e.setState(F(F({}, e.state), { wasHidden: !0 }));
      }, e.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && e.setHiddenStatus();
      }, e.clearPreventFocusTimeout = function() {
        e.preventFocusTimeout && clearTimeout(e.preventFocusTimeout);
      }, e.safeFocus = function() {
        setTimeout(function() {
          var r, o;
          (o = (r = e.input) === null || r === void 0 ? void 0 : r.focus) === null || o === void 0 || o.call(r, { preventScroll: !0 });
        }, 0);
      }, e.safeBlur = function() {
        setTimeout(function() {
          var r, o;
          (o = (r = e.input) === null || r === void 0 ? void 0 : r.blur) === null || o === void 0 || o.call(r);
        }, 0);
      }, e.setFocus = function() {
        e.safeFocus();
      }, e.setBlur = function() {
        e.safeBlur(), e.cancelFocusInput();
      }, e.setOpen = function(r, o) {
        o === void 0 && (o = !1), e.setState({
          open: r,
          preSelection: r && e.state.open ? e.state.preSelection : e.calcInitialState().preSelection,
          lastPreSelectChange: Gt
        }, function() {
          r || e.setState(function(s) {
            return {
              focused: o ? s.focused : !1
            };
          }, function() {
            !o && e.setBlur(), e.setState({ inputValue: null });
          });
        });
      }, e.inputOk = function() {
        return Pe(e.state.preSelection);
      }, e.isCalendarOpen = function() {
        return e.props.open === void 0 ? e.state.open && !e.props.disabled && !e.props.readOnly : e.props.open;
      }, e.handleFocus = function(r) {
        var o, s, i = e.state.wasHidden, l = i ? e.state.open : !0;
        i && e.resetHiddenStatus(), !e.state.preventFocus && l && ((s = (o = e.props).onFocus) === null || s === void 0 || s.call(o, r), !e.props.preventOpenOnFocus && !e.props.readOnly && e.setOpen(!0)), e.setState({ focused: !0 });
      }, e.sendFocusBackToInput = function() {
        e.preventFocusTimeout && e.clearPreventFocusTimeout(), e.setState({ preventFocus: !0 }, function() {
          e.preventFocusTimeout = setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        });
      }, e.cancelFocusInput = function() {
        clearTimeout(e.inputFocusTimeout), e.inputFocusTimeout = void 0;
      }, e.deferFocusInput = function() {
        e.cancelFocusInput(), e.inputFocusTimeout = setTimeout(function() {
          return e.setFocus();
        }, 1);
      }, e.handleDropdownFocus = function() {
        e.cancelFocusInput();
      }, e.handleBlur = function(r) {
        var o, s;
        (!e.state.open || e.props.withPortal || e.props.showTimeInput) && ((s = (o = e.props).onBlur) === null || s === void 0 || s.call(o, r)), e.setState({ focused: !1 });
      }, e.handleCalendarClickOutside = function(r) {
        var o, s;
        e.props.inline || e.setOpen(!1), (s = (o = e.props).onClickOutside) === null || s === void 0 || s.call(o, r), e.props.withPortal && r.preventDefault();
      }, e.handleChange = function() {
        for (var r, o, s = [], i = 0; i < arguments.length; i++)
          s[i] = arguments[i];
        var l = s[0];
        if (!(e.props.onChangeRaw && (e.props.onChangeRaw.apply(e, s), !l || typeof l.isDefaultPrevented != "function" || l.isDefaultPrevented()))) {
          e.setState({
            inputValue: (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : null,
            lastPreSelectChange: Pi
          });
          var c = e.props, u = c.dateFormat, d = u === void 0 ? a.defaultProps.dateFormat : u, p = c.strictParsing, f = p === void 0 ? a.defaultProps.strictParsing : p, h = c.selectsRange, g = c.startDate, v = c.endDate, D = (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : "";
          if (h) {
            var x = D.split("-", 2).map(function(I) {
              return I.trim();
            }), k = x[0], E = x[1], S = $t(k ?? "", d, e.props.locale, f), N = $t(E ?? "", d, e.props.locale, f), w = (g == null ? void 0 : g.getTime()) !== (S == null ? void 0 : S.getTime()), _ = (v == null ? void 0 : v.getTime()) !== (N == null ? void 0 : N.getTime());
            if (!w && !_ || S && ie(S, e.props) || N && ie(N, e.props))
              return;
            (o = (r = e.props).onChange) === null || o === void 0 || o.call(r, [S, N], l);
          } else {
            var C = $t(D, d, e.props.locale, f, e.props.minDate);
            e.props.showTimeSelectOnly && e.props.selected && C && !L(C, e.props.selected) && (C = ko(e.props.selected, {
              hours: ge(C),
              minutes: De(C),
              seconds: Me(C)
            })), (C || !D) && e.setSelected(C, l, !0);
          }
        }
      }, e.handleSelect = function(r, o, s) {
        if (e.props.shouldCloseOnSelect && !e.props.showTimeSelect && e.sendFocusBackToInput(), e.props.onChangeRaw && e.props.onChangeRaw(o), e.setSelected(r, o, !1, s), e.props.showDateSelect && e.setState({ isRenderAriaLiveMessage: !0 }), !e.props.shouldCloseOnSelect || e.props.showTimeSelect)
          e.setPreSelection(r);
        else if (!e.props.inline) {
          e.props.selectsRange || e.setOpen(!1);
          var i = e.props, l = i.startDate, c = i.endDate;
          l && !c && (e.props.swapRange || !zr(r, l)) && e.setOpen(!1);
        }
      }, e.setSelected = function(r, o, s, i) {
        var l, c, u = r;
        if (e.props.showYearPicker) {
          if (u !== null && _t(Y(u), e.props))
            return;
        } else if (e.props.showMonthYearPicker) {
          if (u !== null && Tn(u, e.props))
            return;
        } else if (u !== null && ie(u, e.props))
          return;
        var d = e.props, p = d.onChange, f = d.selectsRange, h = d.startDate, g = d.endDate, v = d.selectsMultiple, D = d.selectedDates, x = d.minTime, k = d.swapRange;
        if (!Ie(e.props.selected, u) || e.props.allowSameDay || f || v)
          if (u !== null && (e.props.selected && (!s || !e.props.showTimeSelect && !e.props.showTimeSelectOnly && !e.props.showTimeInput) && (u = jt(u, {
            hour: ge(e.props.selected),
            minute: De(e.props.selected),
            second: Me(e.props.selected)
          })), !s && (e.props.showTimeSelect || e.props.showTimeSelectOnly) && x && (u = jt(u, {
            hour: x.getHours(),
            minute: x.getMinutes(),
            second: x.getSeconds()
          })), e.props.inline || e.setState({
            preSelection: u
          }), e.props.focusSelectedMonth || e.setState({ monthSelectedIn: i })), f) {
            var E = !h && !g, S = h && !g, N = h && g;
            E ? p == null || p([u, null], o) : S && (u === null ? p == null || p([null, null], o) : zr(u, h) ? k ? p == null || p([u, h], o) : p == null || p([u, null], o) : p == null || p([h, u], o)), N && (p == null || p([u, null], o));
          } else if (v) {
            if (u !== null)
              if (!(D != null && D.length))
                p == null || p([u], o);
              else {
                var w = D.some(function(C) {
                  return L(C, u);
                });
                if (w) {
                  var _ = D.filter(function(C) {
                    return !L(C, u);
                  });
                  p == null || p(_, o);
                } else
                  p == null || p(me(me([], D, !0), [u], !1), o);
              }
          } else
            p == null || p(u, o);
        s || ((c = (l = e.props).onSelect) === null || c === void 0 || c.call(l, u, o), e.setState({ inputValue: null }));
      }, e.setPreSelection = function(r) {
        var o = Pe(e.props.minDate), s = Pe(e.props.maxDate), i = !0;
        if (r) {
          var l = bt(r);
          if (o && s)
            i = Je(r, e.props.minDate, e.props.maxDate);
          else if (o) {
            var c = bt(e.props.minDate);
            i = Ne(r, c) || Ie(l, c);
          } else if (s) {
            var u = Fr(e.props.maxDate);
            i = We(r, u) || Ie(l, u);
          }
        }
        i && e.setState({
          preSelection: r
        });
      }, e.toggleCalendar = function() {
        e.setOpen(!e.state.open);
      }, e.handleTimeChange = function(r) {
        var o, s;
        if (!(e.props.selectsRange || e.props.selectsMultiple)) {
          var i = e.props.selected ? e.props.selected : e.getPreSelection(), l = e.props.selected ? r : jt(i, {
            hour: ge(r),
            minute: De(r)
          });
          e.setState({
            preSelection: l
          }), (s = (o = e.props).onChange) === null || s === void 0 || s.call(o, l), e.props.shouldCloseOnSelect && !e.props.showTimeInput && (e.sendFocusBackToInput(), e.setOpen(!1)), e.props.showTimeInput && e.setOpen(!0), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({ isRenderAriaLiveMessage: !0 }), e.setState({ inputValue: null });
        }
      }, e.onInputClick = function() {
        var r, o;
        !e.props.disabled && !e.props.readOnly && e.setOpen(!0), (o = (r = e.props).onInputClick) === null || o === void 0 || o.call(r);
      }, e.onInputKeyDown = function(r) {
        var o, s, i, l, c, u;
        (s = (o = e.props).onKeyDown) === null || s === void 0 || s.call(o, r);
        var d = r.key;
        if (!e.state.open && !e.props.inline && !e.props.preventOpenOnFocus) {
          (d === y.ArrowDown || d === y.ArrowUp || d === y.Enter) && ((i = e.onInputClick) === null || i === void 0 || i.call(e));
          return;
        }
        if (e.state.open) {
          if (d === y.ArrowDown || d === y.ArrowUp) {
            r.preventDefault();
            var p = e.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : e.props.showWeekPicker && e.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : e.props.showFullMonthYearPicker || e.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', f = ((l = e.calendar) === null || l === void 0 ? void 0 : l.containerRef.current) instanceof Element && e.calendar.containerRef.current.querySelector(p);
            f instanceof HTMLElement && f.focus({ preventScroll: !0 });
            return;
          }
          var h = Q(e.state.preSelection);
          d === y.Enter ? (r.preventDefault(), r.target.blur(), e.inputOk() && e.state.lastPreSelectChange === Gt ? (e.handleSelect(h, r), !e.props.shouldCloseOnSelect && e.setPreSelection(h)) : e.setOpen(!1)) : d === y.Escape ? (r.preventDefault(), r.target.blur(), e.sendFocusBackToInput(), e.setOpen(!1)) : d === y.Tab && e.setOpen(!1), e.inputOk() || (u = (c = e.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: Xt });
        }
      }, e.onPortalKeyDown = function(r) {
        var o = r.key;
        o === y.Escape && (r.preventDefault(), e.setState({
          preventFocus: !0
        }, function() {
          e.setOpen(!1), setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        }));
      }, e.onDayKeyDown = function(r) {
        var o, s, i, l, c, u, d = e.props, p = d.minDate, f = d.maxDate, h = d.disabledKeyboardNavigation, g = d.showWeekPicker, v = d.shouldCloseOnSelect, D = d.locale, x = d.calendarStartDay, k = d.adjustDateOnChange, E = d.inline;
        if ((s = (o = e.props).onKeyDown) === null || s === void 0 || s.call(o, r), !h) {
          var S = r.key, N = r.shiftKey, w = Q(e.state.preSelection), _ = function(B, P) {
            var R = P;
            switch (B) {
              case y.ArrowRight:
                R = g ? Mt(P, 1) : ve(P, 1);
                break;
              case y.ArrowLeft:
                R = g ? Cr(P) : zn(P, 1);
                break;
              case y.ArrowUp:
                R = Cr(P);
                break;
              case y.ArrowDown:
                R = Mt(P, 1);
                break;
              case y.PageUp:
                R = N ? Ue(P, 1) : Le(P, 1);
                break;
              case y.PageDown:
                R = N ? xe(P, 1) : ye(P, 1);
                break;
              case y.Home:
                R = Te(P, D, x);
                break;
              case y.End:
                R = Ws(P);
                break;
            }
            return R;
          }, C = function(B, P) {
            for (var R = 40, O = B, X = !1, ce = 0, ue = _(B, P); !X; ) {
              if (ce >= R) {
                ue = P;
                break;
              }
              p && ue < p && (O = y.ArrowRight, ue = ie(p, e.props) ? _(O, ue) : p), f && ue > f && (O = y.ArrowLeft, ue = ie(f, e.props) ? _(O, ue) : f), ie(ue, e.props) ? ((O === y.PageUp || O === y.Home) && (O = y.ArrowRight), (O === y.PageDown || O === y.End) && (O = y.ArrowLeft), ue = _(O, ue)) : X = !0, ce++;
            }
            return ue;
          };
          if (S === y.Enter) {
            r.preventDefault(), e.handleSelect(w, r), !v && e.setPreSelection(w);
            return;
          } else if (S === y.Escape) {
            r.preventDefault(), e.setOpen(!1), e.inputOk() || (l = (i = e.props).onInputError) === null || l === void 0 || l.call(i, { code: 1, msg: Xt });
            return;
          }
          var I = null;
          switch (S) {
            case y.ArrowLeft:
            case y.ArrowRight:
            case y.ArrowUp:
            case y.ArrowDown:
            case y.PageUp:
            case y.PageDown:
            case y.Home:
            case y.End:
              I = C(S, w);
              break;
          }
          if (!I) {
            (u = (c = e.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: Xt });
            return;
          }
          if (r.preventDefault(), e.setState({ lastPreSelectChange: Gt }), k && e.setSelected(I), e.setPreSelection(I), E) {
            var W = ne(w), A = ne(I), K = Y(w), V = Y(I);
            W !== A || K !== V ? e.setState({ shouldFocusDayInline: !0 }) : e.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, e.onPopperKeyDown = function(r) {
        var o = r.key;
        o === y.Escape && (r.preventDefault(), e.sendFocusBackToInput());
      }, e.onClearClick = function(r) {
        r && r.preventDefault && r.preventDefault(), e.sendFocusBackToInput();
        var o = e.props, s = o.selectsRange, i = o.onChange;
        s ? i == null || i([null, null], r) : i == null || i(null, r), e.setState({ inputValue: null });
      }, e.clear = function() {
        e.onClearClick();
      }, e.onScroll = function(r) {
        typeof e.props.closeOnScroll == "boolean" && e.props.closeOnScroll ? (r.target === document || r.target === document.documentElement || r.target === document.body) && e.setOpen(!1) : typeof e.props.closeOnScroll == "function" && e.props.closeOnScroll(r) && e.setOpen(!1);
      }, e.renderCalendar = function() {
        var r, o;
        return !e.props.inline && !e.isCalendarOpen() ? null : m.createElement(yi, F({ showMonthYearDropdown: void 0, ref: function(s) {
          e.calendar = s;
        } }, e.props, e.state, { setOpen: e.setOpen, dateFormat: (r = e.props.dateFormatCalendar) !== null && r !== void 0 ? r : a.defaultProps.dateFormatCalendar, onSelect: e.handleSelect, onClickOutside: e.handleCalendarClickOutside, holidays: Zs(e.modifyHolidays()), outsideClickIgnoreClass: Zr, onDropdownFocus: e.handleDropdownFocus, onTimeChange: e.handleTimeChange, className: e.props.calendarClassName, container: e.props.calendarContainer, handleOnKeyDown: e.props.onKeyDown, handleOnDayKeyDown: e.onDayKeyDown, setPreSelection: e.setPreSelection, dropdownMode: (o = e.props.dropdownMode) !== null && o !== void 0 ? o : a.defaultProps.dropdownMode }), e.props.children);
      }, e.renderAriaLiveRegion = function() {
        var r = e.props, o = r.dateFormat, s = o === void 0 ? a.defaultProps.dateFormat : o, i = r.locale, l = e.props.showTimeInput || e.props.showTimeSelect, c = l ? "PPPPp" : "PPPP", u;
        return e.props.selectsRange ? u = "Selected start date: ".concat(se(e.props.startDate, {
          dateFormat: c,
          locale: i
        }), ". ").concat(e.props.endDate ? "End date: " + se(e.props.endDate, {
          dateFormat: c,
          locale: i
        }) : "") : e.props.showTimeSelectOnly ? u = "Selected time: ".concat(se(e.props.selected, { dateFormat: s, locale: i })) : e.props.showYearPicker ? u = "Selected year: ".concat(se(e.props.selected, { dateFormat: "yyyy", locale: i })) : e.props.showMonthYearPicker ? u = "Selected month: ".concat(se(e.props.selected, { dateFormat: "MMMM yyyy", locale: i })) : e.props.showQuarterYearPicker ? u = "Selected quarter: ".concat(se(e.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: i
        })) : u = "Selected date: ".concat(se(e.props.selected, {
          dateFormat: c,
          locale: i
        })), m.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, u);
      }, e.renderDateInput = function() {
        var r, o, s, i = ee(e.props.className, (r = {}, r[Zr] = e.state.open, r)), l = e.props.customInput || m.createElement("input", { type: "text" }), c = e.props.customInputRef || "ref", u = e.props, d = u.dateFormat, p = d === void 0 ? a.defaultProps.dateFormat : d, f = u.locale, h = typeof e.props.value == "string" ? e.props.value : typeof e.state.inputValue == "string" ? e.state.inputValue : e.props.selectsRange ? Ls(e.props.startDate, e.props.endDate, {
          dateFormat: p,
          locale: f
        }) : e.props.selectsMultiple ? Fs((s = e.props.selectedDates) !== null && s !== void 0 ? s : [], {
          dateFormat: p,
          locale: f
        }) : se(e.props.selected, {
          dateFormat: p,
          locale: f
        });
        return tn(l, (o = {}, o[c] = function(g) {
          e.input = g;
        }, o.value = h, o.onBlur = e.handleBlur, o.onChange = e.handleChange, o.onClick = e.onInputClick, o.onFocus = e.handleFocus, o.onKeyDown = e.onInputKeyDown, o.id = e.props.id, o.name = e.props.name, o.form = e.props.form, o.autoFocus = e.props.autoFocus, o.placeholder = e.props.placeholderText, o.disabled = e.props.disabled, o.autoComplete = e.props.autoComplete, o.className = ee(l.props.className, i), o.title = e.props.title, o.readOnly = e.props.readOnly, o.required = e.props.required, o.tabIndex = e.props.tabIndex, o["aria-describedby"] = e.props.ariaDescribedBy, o["aria-invalid"] = e.props.ariaInvalid, o["aria-labelledby"] = e.props.ariaLabelledBy, o["aria-required"] = e.props.ariaRequired, o));
      }, e.renderClearButton = function() {
        var r = e.props, o = r.isClearable, s = r.disabled, i = r.selected, l = r.startDate, c = r.endDate, u = r.clearButtonTitle, d = r.clearButtonClassName, p = d === void 0 ? "" : d, f = r.ariaLabelClose, h = f === void 0 ? "Close" : f, g = r.selectedDates;
        return o && (i != null || l != null || c != null || g != null && g.length) ? m.createElement("button", { type: "button", className: ee("react-datepicker__close-icon", p, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": h, onClick: e.onClearClick, title: u, tabIndex: -1 }) : null;
      }, e.state = e.calcInitialState(), e.preventFocusTimeout = void 0, e;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: lt,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, a.prototype.componentDidUpdate = function(t, e) {
      var r, o, s, i;
      t.inline && Si(t.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: Ur(this.props.highlightDates)
      }), !e.focused && !Ie(t.selected, this.props.selected) && this.setState({ inputValue: null }), e.open !== this.state.open && (e.open === !1 && this.state.open === !0 && ((o = (r = this.props).onCalendarOpen) === null || o === void 0 || o.call(r)), e.open === !0 && this.state.open === !1 && ((i = (s = this.props).onCalendarClose) === null || i === void 0 || i.call(s)));
    }, a.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, a.prototype.renderInputContainer = function() {
      var t = this.props, e = t.showIcon, r = t.icon, o = t.calendarIconClassname, s = t.calendarIconClassName, i = t.toggleCalendarOnIconClick, l = this.state.open;
      return o && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), m.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(e ? " react-datepicker__view-calendar-icon" : "") },
        e && m.createElement(bi, F({ icon: r, className: ee(s, !s && o, l && "react-datepicker-ignore-onclickoutside") }, i ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, a.prototype.render = function() {
      var t = this.renderCalendar();
      if (this.props.inline)
        return t;
      if (this.props.withPortal) {
        var e = this.state.open ? m.createElement(
          In,
          { enableTabLoop: this.props.enableTabLoop },
          m.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)
        ) : null;
        return this.state.open && this.props.portalId && (e = m.createElement(Yn, F({ portalId: this.props.portalId }, this.props), e)), m.createElement(
          "div",
          null,
          this.renderInputContainer(),
          e
        );
      }
      return m.createElement(Ci, F({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: t, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, a;
  }(Z)
), Pi = "input", Gt = "navigate";
function Ai({
  onChange: n = null,
  name: a = "selectedDate",
  selected: t = null,
  label: e = "",
  width: r = 100,
  helpText: o = "",
  ...s
}) {
  const i = kt(null), [l, c] = Bn(t), u = (p) => {
    c(p), i !== null && (i.current.value = er(p, "yyyy-MM-dd"));
  }, d = Qn(({ value: p, onClick: f }, h) => /* @__PURE__ */ Se(Zn, { onClick: f, defaultValue: p, label: e, width: r, showValidation: !1, helpText: o, ref: h }));
  return /* @__PURE__ */ Jr(
    "div",
    {
      onClick: (p) => {
        p.target.classList.contains("react-datepicker__day") || p.stopPropagation();
      },
      style: {
        display: "contents",
        "--react-datepicker-wrapper-width": `${r}%`
      },
      children: [
        /* @__PURE__ */ Se(
          Ei,
          {
            onChange: n ?? u,
            selected: l,
            customInput: /* @__PURE__ */ Se(d, {}),
            ...s
          }
        ),
        /* @__PURE__ */ Se("input", { type: "hidden", ref: i, name: a })
      ]
    }
  );
}
export {
  Ai as DatePicker,
  Ai as default
};
